var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
!
/**
* Highcharts JS v12.4.0 (2025-09-04)
* @module highcharts/highcharts-more
* @requires highcharts
*
* (c) 2009-2025 Highsoft AS
*
* License: www.highcharts.com/license
*/
function (t, e) {
  exports = e(t._Highcharts, t._Highcharts.SeriesRegistry, t._Highcharts.Series, t._Highcharts.Series.types.column, t._Highcharts.Templating, t._Highcharts.Point, t._Highcharts.Color, t._Highcharts.Chart, t._Highcharts.SVGElement, t._Highcharts.StackItem);
}("undefined" == typeof window ? exports : window, (t, e, i, s, a, o, r, n, l, h) => (() => {
  "use strict";

  var p,
    d,
    c,
    u = {
      28: t => {
        t.exports = l;
      },
      184: t => {
        t.exports = h;
      },
      260: t => {
        t.exports = o;
      },
      448: t => {
        t.exports = s;
      },
      512: t => {
        t.exports = e;
      },
      620: t => {
        t.exports = r;
      },
      820: t => {
        t.exports = i;
      },
      944: e => {
        e.exports = t;
      },
      960: t => {
        t.exports = n;
      },
      984: t => {
        t.exports = a;
      }
    },
    g = {};
  function f(t) {
    var e = g[t];
    if (void 0 !== e) return e.exports;
    var i = g[t] = {
      exports: {}
    };
    return u[t](i, i.exports, f), i.exports;
  }
  f.n = t => {
    var e = t && t.__esModule ? () => t.default : () => t;
    return f.d(e, {
      a: e
    }), e;
  }, f.d = (t, e) => {
    for (var i in e) f.o(e, i) && !f.o(t, i) && Object.defineProperty(t, i, {
      enumerable: !0,
      get: e[i]
    });
  }, f.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e);
  var m = {};
  f.d(m, {
    default: () => ak
  });
  var b = f(944),
    y = f.n(b),
    x = f(512),
    P = f.n(x),
    M = f(820),
    v = f.n(M);
  let {
      deg2rad: L
    } = y(),
    {
      fireEvent: k,
      isNumber: w,
      pick: A,
      relativeLength: S
    } = y();
  !function (t) {
    t.getCenter = function () {
      let t = (this || _global).options,
        e = (this || _global).chart,
        i = 2 * (t.slicedOffset || 0),
        s = e.plotWidth - 2 * i,
        a = e.plotHeight - 2 * i,
        o = t.center,
        r = Math.min(s, a),
        n = t.thickness,
        l,
        h = t.size,
        p = t.innerSize || 0,
        d,
        c;
      "string" == typeof h && (h = parseFloat(h)), "string" == typeof p && (p = parseFloat(p));
      let u = [A(o?.[0], "50%"), A(o?.[1], "50%"), A(h && h < 0 ? void 0 : t.size, "100%"), A(p && p < 0 ? void 0 : t.innerSize || 0, "0%")];
      for (!e.angular || (this || _global) instanceof v() || (u[3] = 0), d = 0; d < 4; ++d) c = u[d], l = d < 2 || 2 === d && /%$/.test(c), u[d] = S(c, [s, a, r, u[2]][d]) + (l ? i : 0);
      return u[3] > u[2] && (u[3] = u[2]), w(n) && 2 * n < u[2] && n > 0 && (u[3] = u[2] - 2 * n), k(this || _global, "afterGetCenter", {
        positions: u
      }), u;
    }, t.getStartAndEndRadians = function (t, e) {
      let i = w(t) ? t : 0,
        s = w(e) && e > i && e - i < 360 ? e : i + 360;
      return {
        start: L * (i + -90),
        end: L * (s + -90)
      };
    };
  }(p || (p = {}));
  let T = p,
    {
      addEvent: C,
      correctFloat: N,
      defined: X,
      pick: Y
    } = y();
  function R(t) {
    let e,
      i = this || _global;
    return t && i.pane.forEach(s => {
      I(t.chartX - i.plotLeft, t.chartY - i.plotTop, s.center) && (e = s);
    }), e;
  }
  function I(t, e, i, s, a) {
    let o = !0,
      r = i[0],
      n = i[1],
      l = 2 * Math.PI,
      h = Math.sqrt(Math.pow(t - r, 2) + Math.pow(e - n, 2));
    if (X(s) && X(a)) {
      let i = Math.atan2(N(e - n, 8), N(t - r, 8));
      i = (i + l) % l, s = (s + l) % l, Math.abs((a = (a + l) % l) - s) > 0.000001 && (o = s > a ? i >= s || i <= a : i >= s && i <= a);
    } else o = !0;
    return h <= Math.ceil(i[2] / 2) && o;
  }
  function E(t) {
    (this || _global).polar && (t.options.inverted && ([t.x, t.y] = [t.y, t.x]), t.isInsidePlot = (this || _global).pane.some(e => I(t.x, t.y, e.center, e.axis && e.axis.normalizedStartAngleRad, e.axis && e.axis.normalizedEndAngleRad)));
  }
  function D(t) {
    let e = (this || _global).chart;
    t.hoverPoint && t.hoverPoint.plotX && t.hoverPoint.plotY && e.hoverPane && !I(t.hoverPoint.plotX, t.hoverPoint.plotY, e.hoverPane.center) && (t.hoverPoint = void 0);
  }
  function z(t) {
    let e = (this || _global).chart;
    e.polar ? (e.hoverPane = e.getHoverPane(t), t.filter = function (i) {
      return i.visible && !(!t.shared && i.directTouch) && Y(i.options.enableMouseTracking, !0) && (!e.hoverPane || i.xAxis.pane === e.hoverPane);
    }) : e.hoverPane = void 0;
  }
  let {
      defaultOptions: O
    } = y(),
    H = {
      shape: "circle",
      borderRadius: 0,
      borderWidth: 1,
      borderColor: "#cccccc",
      backgroundColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [[0, "#ffffff"], [1, "#e6e6e6"]]
      },
      from: -Number.MAX_VALUE,
      innerRadius: 0,
      to: Number.MAX_VALUE,
      outerRadius: "105%"
    },
    B = {
      background: H,
      center: ["50%", "50%"],
      size: "85%",
      innerSize: "0%",
      startAngle: 0
    };
  O.pane = B;
  let W = {
      pane: B,
      background: H
    },
    {
      extend: F,
      merge: G,
      splat: q
    } = y();
  class V {
    constructor(t, e) {
      this.coll = "pane", this.init(t, e);
    }
    init(t, e) {
      this.chart = e, this.background = [], e.pane.push(this), this.setOptions(t);
    }
    setOptions(t) {
      this.options = t = G(W.pane, {
        background: this.chart.angular ? {} : void 0
      }, t);
    }
    render() {
      let t = this.options,
        e = this.chart.renderer;
      this.group || (this.group = e.g("pane-group").attr({
        zIndex: t.zIndex || 0
      }).add()), this.updateCenter();
      let i = this.options.background;
      if (i) {
        let t = Math.max((i = q(i)).length, this.background.length || 0);
        for (let e = 0; e < t; e++) i[e] && this.axis ? this.renderBackground(G(W.background, i[e]), e) : this.background[e] && (this.background[e] = this.background[e].destroy(), this.background.splice(e, 1));
      }
    }
    renderBackground(t, e) {
      let i = {
          class: "highcharts-pane " + (t.className || "")
        },
        s = "animate";
      this.chart.styledMode || F(i, {
        fill: t.backgroundColor,
        stroke: t.borderColor,
        "stroke-width": t.borderWidth
      }), this.background[e] || (this.background[e] = this.chart.renderer.path().add(this.group), s = "attr"), this.background[e][s]({
        d: this.axis.getPlotBandPath(t.from, t.to, t)
      }).attr(i);
    }
    updateCenter(t) {
      this.center = (t || this.axis || {}).center = T.getCenter.call(this);
    }
    update(t, e) {
      G(!0, this.options, t), this.setOptions(this.options), this.render(), this.chart.axes.forEach(function (t) {
        t.pane === this && (t.pane = null, t.update({}, e));
      }, this);
    }
  }
  V.compose = function (t, e) {
    let i = t.prototype;
    i.getHoverPane || (i.collectionsWithUpdate.push("pane"), i.getHoverPane = R, C(t, "afterIsInsidePlot", E), C(e, "afterGetHoverData", D), C(e, "beforeGetHoverData", z));
  };
  let {
      area: {
        prototype: {
          pointClass: _,
          pointClass: {
            prototype: U
          }
        }
      }
    } = P().seriesTypes,
    {
      defined: K,
      isNumber: j
    } = y(),
    Z = class extends _ {
      setState() {
        let t = this.state,
          e = this.series,
          i = e.chart.polar;
        K(this.plotHigh) || (this.plotHigh = e.yAxis.toPixels(this.high, !0)), K(this.plotLow) || (this.plotLow = this.plotY = e.yAxis.toPixels(this.low, !0)), e.lowerStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.upperStateMarkerGraphic, this.graphic = this.graphics && this.graphics[1], this.plotY = this.plotHigh, i && j(this.plotHighX) && (this.plotX = this.plotHighX), U.setState.apply(this, arguments), this.state = t, this.plotY = this.plotLow, this.graphic = this.graphics && this.graphics[0], i && j(this.plotLowX) && (this.plotX = this.plotLowX), e.upperStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.lowerStateMarkerGraphic, e.lowerStateMarkerGraphic = void 0;
        let s = e.modifyMarkerSettings();
        U.setState.apply(this, arguments), e.restoreMarkerSettings(s);
      }
      haloPath() {
        let t = this.series.chart.polar,
          e = [];
        return this.plotY = this.plotLow, t && j(this.plotLowX) && (this.plotX = this.plotLowX), this.isInside && (e = U.haloPath.apply(this, arguments)), this.plotY = this.plotHigh, t && j(this.plotHighX) && (this.plotX = this.plotHighX), this.isTopInside && (e = e.concat(U.haloPath.apply(this, arguments))), e;
      }
      isValid() {
        return j(this.low) && j(this.high);
      }
    },
    {
      noop: $
    } = y(),
    {
      area: Q,
      area: {
        prototype: J
      },
      column: {
        prototype: tt
      }
    } = P().seriesTypes,
    {
      addEvent: te,
      defined: ti,
      extend: ts,
      isArray: ta,
      isNumber: to,
      pick: tr,
      merge: tn
    } = y();
  class tl extends Q {
    toYData(t) {
      return [t.low, t.high];
    }
    highToXY(t) {
      let e = this.chart,
        i = this.xAxis.postTranslate(t.rectPlotX || 0, this.yAxis.len - (t.plotHigh || 0));
      t.plotHighX = i.x - e.plotLeft, t.plotHigh = i.y - e.plotTop, t.plotLowX = t.plotX;
    }
    getGraphPath(t) {
      let e = [],
        i = [],
        s = J.getGraphPath,
        a = this.options,
        o = this.chart.polar,
        r = o && !1 !== a.connectEnds,
        n = a.connectNulls,
        l,
        h,
        p,
        d = a.step;
      for (l = (t = t || this.points).length; l--;) {
        h = t[l];
        let s = o ? {
          plotX: h.rectPlotX,
          plotY: h.yBottom,
          doCurve: !1
        } : {
          plotX: h.plotX,
          plotY: h.plotY,
          doCurve: !1
        };
        h.isNull || r || n || t[l + 1] && !t[l + 1].isNull || i.push(s), p = {
          polarPlotY: h.polarPlotY,
          rectPlotX: h.rectPlotX,
          yBottom: h.yBottom,
          plotX: tr(h.plotHighX, h.plotX),
          plotY: h.plotHigh,
          isNull: h.isNull
        }, i.push(p), e.push(p), h.isNull || r || n || t[l - 1] && !t[l - 1].isNull || i.push(s);
      }
      let c = s.call(this, t);
      d && (!0 === d && (d = "left"), a.step = {
        left: "right",
        center: "center",
        right: "left"
      }[d]);
      let u = s.call(this, e),
        g = s.call(this, i);
      a.step = d;
      let f = [].concat(c, u);
      return !this.chart.polar && g[0] && "M" === g[0][0] && (g[0] = ["L", g[0][1], g[0][2]]), this.graphPath = f, this.areaPath = c.concat(g), f.isArea = !0, f.xMap = c.xMap, this.areaPath.xMap = c.xMap, f;
    }
    drawDataLabels() {
      let t,
        e,
        i,
        s,
        a,
        o = this.points,
        r = o.length,
        n = [],
        l = this.options.dataLabels,
        h = this.chart.inverted;
      if (l) {
        if (ta(l) ? (s = l[0] || {
          enabled: !1
        }, a = l[1] || {
          enabled: !1
        }) : ((s = ts({}, l)).x = l.xHigh, s.y = l.yHigh, (a = ts({}, l)).x = l.xLow, a.y = l.yLow), s.enabled || this.hasDataLabels?.()) {
          for (t = r; t--;) if (e = o[t]) {
            let {
              plotHigh: a = 0,
              plotLow: o = 0
            } = e;
            i = s.inside ? a < o : a > o, e.y = e.high, e._plotY = e.plotY, e.plotY = a, n[t] = e.dataLabel, e.dataLabel = e.dataLabelUpper, e.below = i, h ? s.align || (s.align = i ? "right" : "left") : s.verticalAlign || (s.verticalAlign = i ? "top" : "bottom");
          }
          for (this.options.dataLabels = s, J.drawDataLabels && J.drawDataLabels.apply(this, arguments), t = r; t--;) (e = o[t]) && (e.dataLabelUpper = e.dataLabel, e.dataLabel = n[t], delete e.dataLabels, e.y = e.low, e.plotY = e._plotY);
        }
        if (a.enabled || this.hasDataLabels?.()) {
          for (t = r; t--;) if (e = o[t]) {
            let {
              plotHigh: t = 0,
              plotLow: s = 0
            } = e;
            i = a.inside ? t < s : t > s, e.below = !i, h ? a.align || (a.align = i ? "left" : "right") : a.verticalAlign || (a.verticalAlign = i ? "bottom" : "top");
          }
          this.options.dataLabels = a, J.drawDataLabels && J.drawDataLabels.apply(this, arguments);
        }
        if (s.enabled) for (t = r; t--;) (e = o[t]) && (e.dataLabels = [e.dataLabelUpper, e.dataLabel].filter(function (t) {
          return !!t;
        }));
        this.options.dataLabels = l;
      }
    }
    alignDataLabel() {
      tt.alignDataLabel.apply(this, arguments);
    }
    modifyMarkerSettings() {
      let t = {
        marker: this.options.marker,
        symbol: this.symbol
      };
      if (this.options.lowMarker) {
        let {
          options: {
            marker: t,
            lowMarker: e
          }
        } = this;
        this.options.marker = tn(t, e), e.symbol && (this.symbol = e.symbol);
      }
      return t;
    }
    restoreMarkerSettings(t) {
      this.options.marker = t.marker, this.symbol = t.symbol;
    }
    drawPoints() {
      let t,
        e,
        i = this.points.length,
        s = this.modifyMarkerSettings();
      for (J.drawPoints.apply(this, arguments), this.restoreMarkerSettings(s), t = 0; t < i;) (e = this.points[t]).graphics = e.graphics || [], e.origProps = {
        plotY: e.plotY,
        plotX: e.plotX,
        isInside: e.isInside,
        negative: e.negative,
        zone: e.zone,
        y: e.y
      }, (e.graphic || e.graphics[0]) && (e.graphics[0] = e.graphic), e.graphic = e.graphics[1], e.plotY = e.plotHigh, ti(e.plotHighX) && (e.plotX = e.plotHighX), e.y = tr(e.high, e.origProps.y), e.negative = e.y < (this.options.threshold || 0), this.zones.length && (e.zone = e.getZone()), this.chart.polar || (e.isInside = e.isTopInside = void 0 !== e.plotY && e.plotY >= 0 && e.plotY <= this.yAxis.len && e.plotX >= 0 && e.plotX <= this.xAxis.len), t++;
      for (J.drawPoints.apply(this, arguments), t = 0; t < i;) (e = this.points[t]).graphics = e.graphics || [], (e.graphic || e.graphics[1]) && (e.graphics[1] = e.graphic), e.graphic = e.graphics[0], e.origProps && (ts(e, e.origProps), delete e.origProps), t++;
    }
    hasMarkerChanged(t, e) {
      let i = t.lowMarker,
        s = e.lowMarker || {};
      return i && (!1 === i.enabled || s.symbol !== i.symbol || s.height !== i.height || s.width !== i.width) || super.hasMarkerChanged(t, e);
    }
  }
  tl.defaultOptions = tn(Q.defaultOptions, {
    lineWidth: 1,
    threshold: null,
    tooltip: {
      pointFormat: "<span style=\"color:{series.color}\">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>"
    },
    trackByArea: !0,
    dataLabels: {
      align: void 0,
      verticalAlign: void 0,
      xLow: 0,
      xHigh: 0,
      yLow: 0,
      yHigh: 0
    }
  }), te(tl, "afterTranslate", function () {
    "low,high" === (this || _global).pointArrayMap.join(",") && (this || _global).points.forEach(t => {
      let e = t.high,
        i = t.plotY;
      t.isNull ? t.plotY = void 0 : (t.plotLow = i, t.plotHigh = to(e) ? (this || _global).yAxis.translate((this || _global).dataModify ? (this || _global).dataModify.modifyValue(e) : e, !1, !0, void 0, !0) : void 0, (this || _global).dataModify && (t.yBottom = t.plotHigh));
    });
  }, {
    order: 0
  }), te(tl, "afterTranslate", function () {
    (this || _global).points.forEach(t => {
      if ((this || _global).chart.polar) this.highToXY(t), t.plotLow = t.plotY, t.tooltipPos = [((t.plotHighX || 0) + (t.plotLowX || 0)) / 2, ((t.plotHigh || 0) + (t.plotLow || 0)) / 2];else {
        let e = t.pos(!1, t.plotLow),
          i = t.pos(!1, t.plotHigh);
        e && i && (e[0] = (e[0] + i[0]) / 2, e[1] = (e[1] + i[1]) / 2), t.tooltipPos = e;
      }
    });
  }, {
    order: 3
  }), ts(tl.prototype, {
    deferTranslatePolar: !0,
    pointArrayMap: ["low", "high"],
    pointClass: Z,
    pointValKey: "low",
    setStackedPoints: $
  }), P().registerSeriesType("arearange", tl);
  let th = tl,
    {
      spline: {
        prototype: tp
      }
    } = P().seriesTypes,
    {
      merge: td,
      extend: tc
    } = y();
  class tu extends th {}
  tu.defaultOptions = td(th.defaultOptions), tc(tu.prototype, {
    getPointSpline: tp.getPointSpline
  }), P().registerSeriesType("areasplinerange", tu);
  var tg = f(448),
    tf = f.n(tg);
  let {
      noop: tm
    } = y(),
    {
      crisp: tb,
      extend: ty,
      merge: tx,
      pick: tP,
      relativeLength: tM
    } = y();
  class tv extends tf() {
    pointAttribs() {
      return {};
    }
    getWhiskerPair(t, e, i, s, a) {
      let o = a.whiskers.strokeWidth(),
        r = (i, s) => {
          let a = tM(i, 2 * t) / 2,
            r = tb(s, o);
          return [["M", tb(e - a), r], ["L", tb(e + a), r]];
        };
      return [...r(i, a.highPlot), ...r(s, a.lowPlot)];
    }
    translate() {
      let t = this.yAxis,
        e = this.pointArrayMap;
      super.translate.apply(this), this.points.forEach(function (i) {
        e.forEach(function (e) {
          null !== i[e] && (i[e + "Plot"] = t.translate(i[e], 0, 1, 0, 1));
        }), i.plotHigh = i.highPlot;
      });
    }
    drawPoints() {
      let t,
        e,
        i,
        s,
        a,
        o,
        r,
        n,
        l,
        h,
        p,
        d = this.points,
        c = this.options,
        u = this.chart,
        g = u.renderer,
        f = !1 !== this.doQuartiles,
        m = this.options.whiskerLength;
      for (let b of d) {
        let d = (n = b.graphic) ? "animate" : "attr",
          y = b.shapeArgs,
          x = {},
          P = {},
          M = {},
          v = {},
          L = b.color || this.color,
          k = b.options.whiskerLength || m;
        if (void 0 !== b.plotY) {
          let w;
          l = y.width, p = (h = y.x) + l, t = f ? b.q1Plot : b.lowPlot, e = f ? b.q3Plot : b.lowPlot, i = b.highPlot, s = b.lowPlot, n || (b.graphic = n = g.g("point").add(this.group), b.stem = g.path().addClass("highcharts-boxplot-stem").add(n), m && (b.whiskers = g.path().addClass("highcharts-boxplot-whisker").add(n)), f && (b.box = g.path(r).addClass("highcharts-boxplot-box").add(n)), b.medianShape = g.path(o).addClass("highcharts-boxplot-median").add(n)), u.styledMode || (P.stroke = b.stemColor || c.stemColor || L, P["stroke-width"] = tP(b.stemWidth, c.stemWidth, c.lineWidth), P.dashstyle = b.stemDashStyle || c.stemDashStyle || c.dashStyle, b.stem.attr(P), k && (M.stroke = b.whiskerColor || c.whiskerColor || L, M["stroke-width"] = tP(b.whiskerWidth, c.whiskerWidth, c.lineWidth), M.dashstyle = b.whiskerDashStyle || c.whiskerDashStyle || c.dashStyle, b.whiskers.attr(M)), f && (x.fill = b.fillColor || c.fillColor || L, x.stroke = c.lineColor || L, x["stroke-width"] = c.lineWidth || 0, x.dashstyle = b.boxDashStyle || c.boxDashStyle || c.dashStyle, b.box.attr(x)), v.stroke = b.medianColor || c.medianColor || L, v["stroke-width"] = tP(b.medianWidth, c.medianWidth, c.lineWidth), v.dashstyle = b.medianDashStyle || c.medianDashStyle || c.dashStyle, b.medianShape.attr(v));
          let A = tb((b.plotX || 0) + (this.pointXOffset || 0) + (this.barW || 0) / 2, b.stem.strokeWidth());
          if (w = [["M", A, e], ["L", A, i], ["M", A, t], ["L", A, s]], b.stem[d]({
            d: w
          }), f) {
            let i = b.box.strokeWidth();
            t = tb(t, i), e = tb(e, i), w = [["M", h = tb(h, i), e], ["L", h, t], ["L", p = tb(p, i), t], ["L", p, e], ["L", h, e], ["Z"]], b.box[d]({
              d: w
            });
          }
          if (k) {
            let t = l / 2,
              e = this.getWhiskerPair(t, A, b.upperWhiskerLength ?? c.upperWhiskerLength ?? k, b.lowerWhiskerLength ?? c.lowerWhiskerLength ?? k, b);
            b.whiskers[d]({
              d: e
            });
          }
          w = [["M", h, a = tb(b.medianPlot, b.medianShape.strokeWidth())], ["L", p, a]], b.medianShape[d]({
            d: w
          });
        }
      }
    }
    toYData(t) {
      return [t.low, t.q1, t.median, t.q3, t.high];
    }
  }
  tv.defaultOptions = tx(tf().defaultOptions, {
    threshold: null,
    tooltip: {
      pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> <b>{series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>"
    },
    whiskerLength: "50%",
    fillColor: "#ffffff",
    lineWidth: 1,
    medianWidth: 2,
    whiskerWidth: 2
  }), ty(tv.prototype, {
    pointArrayMap: ["low", "q1", "median", "q3", "high"],
    pointValKey: "high",
    drawDataLabels: tm,
    setStackedPoints: tm
  }), P().registerSeriesType("boxplot", tv);
  let tL = tv,
    tk = {
      borderColor: void 0,
      borderWidth: 2,
      className: void 0,
      color: void 0,
      connectorClassName: void 0,
      connectorColor: void 0,
      connectorDistance: 60,
      connectorWidth: 1,
      enabled: !1,
      labels: {
        className: void 0,
        allowOverlap: !1,
        format: "",
        formatter: void 0,
        align: "right",
        style: {
          fontSize: "0.9em",
          color: "#000000"
        },
        x: 0,
        y: 0
      },
      maxSize: 60,
      minSize: 10,
      legendIndex: 0,
      ranges: {
        value: void 0,
        borderColor: void 0,
        color: void 0,
        connectorColor: void 0
      },
      sizeBy: "area",
      sizeByAbsoluteValue: !1,
      zIndex: 1,
      zThreshold: 0
    };
  var tw = f(984),
    tA = f.n(tw);
  let {
      noop: tS
    } = y(),
    {
      arrayMax: tT,
      arrayMin: tC,
      isNumber: tN,
      merge: tX,
      pick: tY,
      stableSort: tR
    } = y(),
    tI = class {
      constructor(t, e) {
        this.setState = tS, this.init(t, e);
      }
      init(t, e) {
        this.options = t, this.visible = !0, this.chart = e.chart, this.legend = e;
      }
      addToLegend(t) {
        t.splice(this.options.legendIndex, 0, this);
      }
      drawLegendSymbol(t) {
        let e,
          i = tY(t.options.itemDistance, 20),
          s = this.legendItem || {},
          a = this.options,
          o = a.ranges,
          r = a.connectorDistance;
        if (!o || !o.length || !tN(o[0].value)) {
          t.options.bubbleLegend.autoRanges = !0;
          return;
        }
        tR(o, function (t, e) {
          return e.value - t.value;
        }), this.ranges = o, this.setOptions(), this.render();
        let n = this.getMaxLabelSize(),
          l = this.ranges[0].radius,
          h = 2 * l;
        e = (e = r - l + n.width) > 0 ? e : 0, this.maxLabel = n, this.movementX = "left" === a.labels.align ? e : 0, s.labelWidth = h + e + i, s.labelHeight = h + n.height / 2;
      }
      setOptions() {
        let t = this.ranges,
          e = this.options,
          i = this.chart.series[e.seriesIndex],
          s = this.legend.baseline,
          a = {
            zIndex: e.zIndex,
            "stroke-width": e.borderWidth
          },
          o = {
            zIndex: e.zIndex,
            "stroke-width": e.connectorWidth
          },
          r = {
            align: this.legend.options.rtl || "left" === e.labels.align ? "right" : "left",
            zIndex: e.zIndex
          },
          n = i.options.marker.fillOpacity,
          l = this.chart.styledMode;
        t.forEach(function (h, p) {
          l || (a.stroke = tY(h.borderColor, e.borderColor, i.color), a.fill = h.color || e.color, a.fill || (a.fill = i.color, a["fill-opacity"] = n ?? 1), o.stroke = tY(h.connectorColor, e.connectorColor, i.color)), t[p].radius = this.getRangeRadius(h.value), t[p] = tX(t[p], {
            center: t[0].radius - t[p].radius + s
          }), l || tX(!0, t[p], {
            bubbleAttribs: tX(a),
            connectorAttribs: tX(o),
            labelAttribs: r
          });
        }, this);
      }
      getRangeRadius(t) {
        let e = this.options,
          i = this.options.seriesIndex,
          s = this.chart.series[i],
          a = e.ranges[0].value,
          o = e.ranges[e.ranges.length - 1].value,
          r = e.minSize,
          n = e.maxSize;
        return s.getRadius.call(this, o, a, r, n, t);
      }
      render() {
        let t = this.legendItem || {},
          e = this.chart.renderer,
          i = this.options.zThreshold;
        for (let s of (this.symbols || (this.symbols = {
          connectors: [],
          bubbleItems: [],
          labels: []
        }), t.symbol = e.g("bubble-legend"), t.label = e.g("bubble-legend-item").css(this.legend.itemStyle || {}), t.symbol.translateX = 0, t.symbol.translateY = 0, t.symbol.add(t.label), t.label.add(t.group), this.ranges)) s.value >= i && this.renderRange(s);
        this.hideOverlappingLabels();
      }
      renderRange(t) {
        let e = this.ranges[0],
          i = this.legend,
          s = this.options,
          a = s.labels,
          o = this.chart,
          r = o.series[s.seriesIndex],
          n = o.renderer,
          l = this.symbols,
          h = l.labels,
          p = t.center,
          d = Math.abs(t.radius),
          c = s.connectorDistance || 0,
          u = a.align,
          g = i.options.rtl,
          f = s.borderWidth,
          m = s.connectorWidth,
          b = e.radius || 0,
          y = p - d - f / 2 + m / 2,
          x = (y % 1 ? 1 : 0.5) - (m % 2 ? 0 : 0.5),
          P = n.styledMode,
          M = g || "left" === u ? -c : c;
        "center" === u && (M = 0, s.connectorDistance = 0, t.labelAttribs.align = "center"), l.bubbleItems.push(n.circle(b, p + x, d).attr(P ? {} : t.bubbleAttribs).addClass((P ? "highcharts-color-" + r.colorIndex + " " : "") + "highcharts-bubble-legend-symbol " + (s.className || "")).add(this.legendItem.symbol)), l.connectors.push(n.path(n.crispLine([["M", b, y], ["L", b + M, y]], s.connectorWidth)).attr(P ? {} : t.connectorAttribs).addClass((P ? "highcharts-color-" + this.options.seriesIndex + " " : "") + "highcharts-bubble-legend-connectors " + (s.connectorClassName || "")).add(this.legendItem.symbol));
        let v = n.text(this.formatLabel(t)).attr(P ? {} : t.labelAttribs).css(P ? {} : a.style).addClass("highcharts-bubble-legend-labels " + (s.labels.className || "")).add(this.legendItem.symbol),
          L = {
            x: b + M + s.labels.x,
            y: y + s.labels.y + 0.4 * v.getBBox().height
          };
        v.attr(L), h.push(v), v.placed = !0, v.alignAttr = L;
      }
      getMaxLabelSize() {
        let t, e;
        return this.symbols.labels.forEach(function (i) {
          e = i.getBBox(!0), t = t ? e.width > t.width ? e : t : e;
        }), t || {};
      }
      formatLabel(t) {
        let e = this.options,
          i = e.labels.formatter,
          s = e.labels.format,
          {
            numberFormatter: a
          } = this.chart;
        return s ? tA().format(s, t, this.chart) : i ? i.call(t) : a(t.value, 1);
      }
      hideOverlappingLabels() {
        let t = this.chart,
          e = this.options.labels.allowOverlap,
          i = this.symbols;
        !e && i && (t.hideOverlappingLabels(i.labels), i.labels.forEach(function (t, e) {
          t.newOpacity ? t.newOpacity !== t.oldOpacity && i.connectors[e].show() : i.connectors[e].hide();
        }));
      }
      getRanges() {
        let t = this.legend.bubbleLegend,
          e = t.chart.series,
          i = t.options.ranges,
          s,
          a,
          o = Number.MAX_VALUE,
          r = -Number.MAX_VALUE;
        return e.forEach(function (t) {
          t.isBubble && !t.ignoreSeries && (a = t.getColumn("z").filter(tN)).length && (o = tY(t.options.zMin, Math.min(o, Math.max(tC(a), !1 === t.options.displayNegative ? t.options.zThreshold : -Number.MAX_VALUE))), r = tY(t.options.zMax, Math.max(r, tT(a))));
        }), s = o === r ? [{
          value: r
        }] : [{
          value: o
        }, {
          value: (o + r) / 2
        }, {
          value: r,
          autoRanges: !0
        }], i.length && i[0].radius && s.reverse(), s.forEach(function (t, e) {
          i && i[e] && (s[e] = tX(i[e], t));
        }), s;
      }
      predictBubbleSizes() {
        let t = this.chart,
          e = t.legend.options,
          i = e.floating,
          s = "horizontal" === e.layout,
          a = s ? t.legend.lastLineHeight : 0,
          o = t.plotSizeX,
          r = t.plotSizeY,
          n = t.series[this.options.seriesIndex],
          l = n.getPxExtremes(),
          h = Math.ceil(l.minPxSize),
          p = Math.ceil(l.maxPxSize),
          d = Math.min(r, o),
          c,
          u = n.options.maxSize;
        return i || !/%$/.test(u) ? c = p : (c = (d + a) * (u = parseFloat(u)) / 100 / (u / 100 + 1), (s && r - c >= o || !s && o - c >= r) && (c = p)), [h, Math.ceil(c)];
      }
      updateRanges(t, e) {
        let i = this.legend.options.bubbleLegend;
        i.minSize = t, i.maxSize = e, i.ranges = this.getRanges();
      }
      correctSizes() {
        let t = this.legend,
          e = this.chart.series[this.options.seriesIndex].getPxExtremes();
        Math.abs(Math.ceil(e.maxPxSize) - this.options.maxSize) > 1 && (this.updateRanges(this.options.minSize, e.maxPxSize), t.render());
      }
    },
    {
      setOptions: tE
    } = y(),
    {
      composed: tD
    } = y(),
    {
      addEvent: tz,
      objectEach: tO,
      pushUnique: tH,
      wrap: tB
    } = y();
  function tW(t, e, i) {
    let s,
      a,
      o,
      r = (this || _global).legend,
      n = tF(this || _global) >= 0;
    r && r.options.enabled && r.bubbleLegend && r.options.bubbleLegend.autoRanges && n ? (s = r.bubbleLegend.options, a = r.bubbleLegend.predictBubbleSizes(), r.bubbleLegend.updateRanges(a[0], a[1]), s.placed || (r.group.placed = !1, r.allItems.forEach(t => {
      (o = t.legendItem || {}).group && (o.group.translateY = void 0);
    })), r.render(), s.placed || (this.getMargins(), (this || _global).axes.forEach(t => {
      t.setScale(), t.updateNames(), tO(t.ticks, function (t) {
        t.isNew = !0, t.isNewLabel = !0;
      });
    }), this.getMargins()), s.placed = !0, t.call(this || _global, e, i), r.bubbleLegend.correctSizes(), t_(r, tG(r))) : (t.call(this || _global, e, i), r && r.options.enabled && r.bubbleLegend && (r.render(), t_(r, tG(r))));
  }
  function tF(t) {
    let e = t.series,
      i = 0;
    for (; i < e.length;) {
      if (e[i] && e[i].isBubble && e[i].visible && e[i].dataTable.rowCount) return i;
      i++;
    }
    return -1;
  }
  function tG(t) {
    let e = t.allItems,
      i = [],
      s = e.length,
      a,
      o,
      r,
      n = 0,
      l = 0;
    for (n = 0; n < s; n++) if (o = e[n].legendItem || {}, r = (e[n + 1] || {}).legendItem || {}, o.labelHeight && (e[n].itemHeight = o.labelHeight), e[n] === e[s - 1] || o.y !== r.y) {
      for (i.push({
        height: 0
      }), a = i[i.length - 1]; l <= n; l++) e[l].itemHeight > a.height && (a.height = e[l].itemHeight);
      a.step = n;
    }
    return i;
  }
  function tq(t) {
    let e = (this || _global).bubbleLegend,
      i = (this || _global).options,
      s = i.bubbleLegend,
      a = tF((this || _global).chart);
    e && e.ranges && e.ranges.length && (s.ranges.length && (s.autoRanges = !!s.ranges[0].autoRanges), this.destroyItem(e)), a >= 0 && i.enabled && s.enabled && (s.seriesIndex = a, (this || _global).bubbleLegend = new tI(s, this || _global), (this || _global).bubbleLegend.addToLegend(t.allItems));
  }
  function tV(t) {
    let e;
    if (t.defaultPrevented) return !1;
    let i = t.legendItem,
      s = (this || _global).chart,
      a = i.visible;
    (this || _global) && (this || _global).bubbleLegend && (i.visible = !a, i.ignoreSeries = a, e = tF(s) >= 0, (this || _global).bubbleLegend.visible !== e && (this.update({
      bubbleLegend: {
        enabled: e
      }
    }), (this || _global).bubbleLegend.visible = e), i.visible = a);
  }
  function t_(t, e) {
    let i = t.allItems,
      s = t.options.rtl,
      a,
      o,
      r,
      n,
      l = 0;
    i.forEach((t, i) => {
      (n = t.legendItem || {}).group && (a = n.group.translateX || 0, o = n.y || 0, ((r = t.movementX) || s && t.ranges) && (r = s ? a - t.options.maxSize / 2 : a + r, n.group.attr({
        translateX: r
      })), i > e[l].step && l++, n.group.attr({
        translateY: Math.round(o + e[l].height / 2)
      }), n.y = o + e[l].height / 2);
    });
  }
  let tU = {
    compose: function (t, e) {
      tH(tD, "Series.BubbleLegend") && (tE({
        legend: {
          bubbleLegend: tk
        }
      }), tB(t.prototype, "drawChartBox", tW), tz(e, "afterGetAllItems", tq), tz(e, "itemClick", tV));
    }
  };
  var tK = f(260),
    tj = f.n(tK);
  let {
      seriesTypes: {
        scatter: {
          prototype: {
            pointClass: tZ
          }
        }
      }
    } = P(),
    {
      extend: t$
    } = y();
  class tQ extends tZ {
    haloPath(t) {
      let e = (t && this.marker && this.marker.radius || 0) + t;
      if (this.series.chart.inverted) {
        let t = this.pos() || [0, 0],
          {
            xAxis: i,
            yAxis: s,
            chart: a
          } = this.series,
          o = 2 * e;
        return a.renderer.symbols.circle((i?.len || 0) - t[1] - e, (s?.len || 0) - t[0] - e, o, o);
      }
      return tj().prototype.haloPath.call(this, e);
    }
  }
  t$(tQ.prototype, {
    ttBelow: !1
  });
  let {
      composed: tJ,
      noop: t0
    } = y(),
    {
      series: t1,
      seriesTypes: {
        column: {
          prototype: t2
        },
        scatter: t3
      }
    } = P(),
    {
      addEvent: t5,
      arrayMax: t8,
      arrayMin: t6,
      clamp: t9,
      extend: t4,
      isNumber: t7,
      merge: et,
      pick: ee,
      pushUnique: ei
    } = y();
  function es() {
    let t = (this || _global).len,
      {
        coll: e,
        isXAxis: i,
        min: s
      } = this || _global,
      a = ((this || _global).max || 0) - (s || 0),
      o = 0,
      r = t,
      n = t / a,
      l;
    ("xAxis" === e || "yAxis" === e) && ((this || _global).series.forEach(t => {
      if (t.bubblePadding && t.reserveSpace()) {
        (this || _global).allowZoomOutside = !0, l = !0;
        let e = t.getColumn(i ? "x" : "y");
        if (i && ((t.onPoint || t).getRadii(0, 0, t), t.onPoint && (t.radii = t.onPoint.radii)), a > 0) {
          let i = e.length;
          for (; i--;) if (t7(e[i]) && (this || _global).dataMin <= e[i] && e[i] <= (this || _global).max) {
            let a = t.radii && t.radii[i] || 0;
            o = Math.min((e[i] - s) * n - a, o), r = Math.max((e[i] - s) * n + a, r);
          }
        }
      }
    }), l && a > 0 && !(this || _global).logarithmic && (r -= t, n *= (t + Math.max(0, o) - Math.min(r, t)) / t, [["min", "userMin", o], ["max", "userMax", r]].forEach(t => {
      void 0 === ee((this || _global).options[t[0]], (this || _global)[t[1]]) && ((this || _global)[t[0]] += t[2] / n);
    })));
  }
  function ea() {
    let {
        ticks: t,
        tickPositions: e,
        dataMin: i = 0,
        dataMax: s = 0,
        categories: a
      } = this || _global,
      o = (this || _global).options.type;
    if ((a?.length || "category" === o) && (this || _global).series.find(t => t.bubblePadding)) {
      let a = e.length;
      for (; a--;) {
        let o = t[e[a]],
          r = o.pos || 0;
        (r > s || r < i) && o.label?.hide();
      }
    }
  }
  class eo extends t3 {
    static compose(t, e, i) {
      tU.compose(e, i), ei(tJ, "Series.Bubble") && (t5(t, "foundExtremes", es), t5(t, "afterRender", ea));
    }
    animate(t) {
      !t && this.points.length < this.options.animationLimit && this.points.forEach(function (t) {
        let {
          graphic: e,
          plotX: i = 0,
          plotY: s = 0
        } = t;
        e && e.width && (this.hasRendered || e.attr({
          x: i,
          y: s,
          width: 1,
          height: 1
        }), e.animate(this.markerAttribs(t), this.options.animation));
      }, this);
    }
    getRadii() {
      let t = this.getColumn("z"),
        e = this.getColumn("y"),
        i = [],
        s,
        a,
        o,
        r = this.chart.bubbleZExtremes,
        {
          minPxSize: n,
          maxPxSize: l
        } = this.getPxExtremes();
      if (!r) {
        let t,
          e = Number.MAX_VALUE,
          i = -Number.MAX_VALUE;
        this.chart.series.forEach(s => {
          if (s.bubblePadding && s.reserveSpace()) {
            let a = (s.onPoint || s).getZExtremes();
            a && (e = Math.min(ee(e, a.zMin), a.zMin), i = Math.max(ee(i, a.zMax), a.zMax), t = !0);
          }
        }), t ? (r = {
          zMin: e,
          zMax: i
        }, this.chart.bubbleZExtremes = r) : r = {
          zMin: 0,
          zMax: 0
        };
      }
      for (a = 0, s = t.length; a < s; a++) o = t[a], i.push(this.getRadius(r.zMin, r.zMax, n, l, o, e && e[a]));
      this.radii = i;
    }
    getRadius(t, e, i, s, a, o) {
      let r = this.options,
        n = "width" !== r.sizeBy,
        l = r.zThreshold,
        h = e - t,
        p = 0.5;
      if (null === o || null === a) return null;
      if (t7(a)) {
        if (r.sizeByAbsoluteValue && (a = Math.abs(a - l), e = h = Math.max(e - l, Math.abs(t - l)), t = 0), a < t) return i / 2 - 1;
        h > 0 && (p = (a - t) / h);
      }
      return n && p >= 0 && (p = Math.sqrt(p)), Math.ceil(i + p * (s - i)) / 2;
    }
    hasData() {
      return !!this.dataTable.rowCount;
    }
    markerAttribs(t, e) {
      let i = super.markerAttribs(t, e),
        {
          height: s = 0,
          width: a = 0
        } = i;
      return this.chart.inverted ? t4(i, {
        x: (t.plotX || 0) - a / 2,
        y: (t.plotY || 0) - s / 2
      }) : i;
    }
    pointAttribs(t, e) {
      let i = this.options.marker,
        s = i?.fillOpacity,
        a = t1.prototype.pointAttribs.call(this, t, e);
      return a["fill-opacity"] = s ?? 1, a;
    }
    translate() {
      super.translate.call(this), this.getRadii(), this.translateBubble();
    }
    translateBubble() {
      let {
          data: t,
          options: e,
          radii: i
        } = this,
        {
          minPxSize: s
        } = this.getPxExtremes(),
        a = t.length;
      for (; a--;) {
        let o = t[a],
          r = i ? i[a] : 0;
        "z" === this.zoneAxis && (o.negative = (o.z || 0) < (e.zThreshold || 0)), t7(r) && r >= s / 2 ? (o.marker = t4(o.marker, {
          radius: r,
          width: 2 * r,
          height: 2 * r
        }), o.dlBox = {
          x: o.plotX - r,
          y: o.plotY - r,
          width: 2 * r,
          height: 2 * r
        }) : (o.shapeArgs = o.plotY = o.dlBox = void 0, o.isInside = !1);
      }
    }
    getPxExtremes() {
      let t = Math.min(this.chart.plotWidth, this.chart.plotHeight),
        e = e => {
          let i;
          return "string" == typeof e && (i = /%$/.test(e), e = parseInt(e, 10)), i ? t * e / 100 : e;
        },
        i = e(ee(this.options.minSize, 8)),
        s = Math.max(e(ee(this.options.maxSize, "20%")), i);
      return {
        minPxSize: i,
        maxPxSize: s
      };
    }
    getZExtremes() {
      let t = this.options,
        e = this.getColumn("z").filter(t7);
      if (e.length) {
        let i = ee(t.zMin, t9(t6(e), !1 === t.displayNegative ? t.zThreshold || 0 : -Number.MAX_VALUE, Number.MAX_VALUE)),
          s = ee(t.zMax, t8(e));
        if (t7(i) && t7(s)) return {
          zMin: i,
          zMax: s
        };
      }
    }
    searchKDTree(t, e, i, s = t0, a = t0) {
      return s = (t, e, i) => {
        let s = t[i] || 0,
          a = e[i] || 0,
          o,
          r = !1;
        return s === a ? o = t.index > e.index ? t : e : s < 0 && a < 0 ? (o = s - (t.marker?.radius || 0) >= a - (e.marker?.radius || 0) ? t : e, r = !0) : o = s < a ? t : e, [o, r];
      }, a = (t, e, i) => !i && t > e || t < e, super.searchKDTree(t, e, i, s, a);
    }
  }
  eo.defaultOptions = et(t3.defaultOptions, {
    dataLabels: {
      formatter: function () {
        let {
            numberFormatter: t
          } = (this || _global).series.chart,
          {
            z: e
          } = (this || _global).point;
        return t7(e) ? t(e, -1) : "";
      },
      inside: !0,
      verticalAlign: "middle"
    },
    animationLimit: 250,
    marker: {
      lineColor: null,
      lineWidth: 1,
      fillOpacity: 0.5,
      radius: null,
      states: {
        hover: {
          radiusPlus: 0
        }
      },
      symbol: "circle"
    },
    minSize: 8,
    maxSize: "20%",
    softThreshold: !1,
    states: {
      hover: {
        halo: {
          size: 5
        }
      }
    },
    tooltip: {
      pointFormat: "({point.x}, {point.y}), Size: {point.z}"
    },
    turboThreshold: 0,
    zThreshold: 0,
    zoneAxis: "z"
  }), t4(eo.prototype, {
    alignDataLabel: t2.alignDataLabel,
    applyZones: t0,
    bubblePadding: !0,
    isBubble: !0,
    keysAffectYAxis: ["y"],
    pointArrayMap: ["y", "z"],
    pointClass: tQ,
    parallelArrays: ["x", "y", "z"],
    trackerGroups: ["group", "dataLabelsGroup"],
    specialGroup: "group",
    zoneAxis: "z"
  }), t5(eo, "updatedData", t => {
    delete t.target.chart.bubbleZExtremes;
  }), t5(eo, "remove", t => {
    delete t.target.chart.bubbleZExtremes;
  }), P().registerSeriesType("bubble", eo);
  let {
      seriesTypes: {
        column: {
          prototype: {
            pointClass: {
              prototype: er
            }
          }
        },
        arearange: {
          prototype: {
            pointClass: en
          }
        }
      }
    } = P(),
    {
      extend: el,
      isNumber: eh
    } = y();
  class ep extends en {
    isValid() {
      return eh(this.low);
    }
  }
  el(ep.prototype, {
    setState: er.setState
  });
  let {
      noop: ed
    } = y(),
    {
      seriesTypes: {
        arearange: ec,
        column: eu,
        column: {
          prototype: eg
        }
      }
    } = P(),
    {
      addEvent: ef,
      clamp: em,
      extend: eb,
      isNumber: ey,
      merge: ex,
      pick: eP
    } = y();
  class eM extends ec {
    setOptions() {
      return ex(!0, arguments[0], {
        stacking: void 0
      }), ec.prototype.setOptions.apply(this, arguments);
    }
    translate() {
      return eg.translate.apply(this);
    }
    pointAttribs() {
      return eg.pointAttribs.apply(this, arguments);
    }
    translate3dPoints() {
      return eg.translate3dPoints.apply(this, arguments);
    }
    translate3dShapes() {
      return eg.translate3dShapes.apply(this, arguments);
    }
    afterColumnTranslate() {
      let t,
        e,
        i,
        s,
        a = this.yAxis,
        o = this.xAxis,
        r = o.startAngleRad,
        n = this.chart,
        l = this.xAxis.isRadial,
        h = Math.max(n.chartWidth, n.chartHeight) + 999;
      this.points.forEach(p => {
        let d = p.shapeArgs || {},
          c = this.options.minPointLength,
          u = p.plotY,
          g = a.translate(p.high, 0, 1, 0, 1);
        if (ey(g) && ey(u)) if (p.plotHigh = em(g, -h, h), p.plotLow = em(u, -h, h), s = p.plotHigh, Math.abs(t = eP(p.rectPlotY, p.plotY) - p.plotHigh) < c ? (e = c - t, t += e, s -= e / 2) : t < 0 && (t *= -1, s -= t), l && this.polar) i = p.barX + r, p.shapeType = "arc", p.shapeArgs = this.polar.arc(s + t, s, i, i + p.pointWidth);else {
          d.height = t, d.y = s;
          let {
            x: e = 0,
            width: i = 0
          } = d;
          p.shapeArgs = ex(p.shapeArgs, this.crispCol(e, s, i, t)), p.tooltipPos = n.inverted ? [a.len + a.pos - n.plotLeft - s - t / 2, o.len + o.pos - n.plotTop - e - i / 2, t] : [o.left - n.plotLeft + e + i / 2, a.pos - n.plotTop + s + t / 2, t];
        }
      });
    }
  }
  eM.defaultOptions = ex(eu.defaultOptions, ec.defaultOptions, {
    borderRadius: {
      where: "all"
    },
    pointRange: null,
    legendSymbol: "rectangle",
    marker: null,
    states: {
      hover: {
        halo: !1
      }
    }
  }), ef(eM, "afterColumnTranslate", function () {
    eM.prototype.afterColumnTranslate.apply(this || _global);
  }, {
    order: 5
  }), eb(eM.prototype, {
    directTouch: !0,
    pointClass: ep,
    trackerGroups: ["group", "dataLabelsGroup"],
    adjustForMissingColumns: eg.adjustForMissingColumns,
    animate: eg.animate,
    crispCol: eg.crispCol,
    drawGraph: ed,
    drawPoints: eg.drawPoints,
    getSymbol: ed,
    drawTracker: eg.drawTracker,
    getColumnMetrics: eg.getColumnMetrics
  }), P().registerSeriesType("columnrange", eM);
  let {
      column: ev
    } = P().seriesTypes,
    {
      clamp: eL,
      merge: ek,
      pick: ew
    } = y();
  class eA extends ev {
    translate() {
      let t = this.chart,
        e = this.options,
        i = this.dense = this.closestPointRange * this.xAxis.transA < 2,
        s = this.borderWidth = ew(e.borderWidth, +!i),
        a = this.yAxis,
        o = e.threshold,
        r = ew(e.minPointLength, 5),
        n = this.getColumnMetrics(),
        l = n.width,
        h = this.pointXOffset = n.offset,
        p = this.translatedThreshold = a.getThreshold(o),
        d = this.barW = Math.max(l, 1 + 2 * s);
      for (let i of (t.inverted && (p -= 0.5), e.pointPadding && (d = Math.ceil(d)), super.translate(), this.points)) {
        let s = ew(i.yBottom, p),
          c = 999 + Math.abs(s),
          u = eL(i.plotY, -c, a.len + c),
          g = d / 2,
          f = Math.min(u, s),
          m = Math.max(u, s) - f,
          b = i.plotX + h,
          y,
          x,
          P,
          M,
          v,
          L,
          k,
          w,
          A,
          S,
          T;
        e.centerInCategory && (b = this.adjustForMissingColumns(b, l, i, n)), i.barX = b, i.pointWidth = l, i.tooltipPos = t.inverted ? [a.len + a.pos - t.plotLeft - u, this.xAxis.len - b - g, m] : [b + g, u + a.pos - t.plotTop, m], y = o + (i.total || i.y), "percent" === e.stacking && (y = o + (i.y < 0) ? -100 : 100);
        let C = a.toPixels(y, !0);
        P = (x = t.plotHeight - C - (t.plotHeight - p)) ? g * (f - C) / x : 0, M = x ? g * (f + m - C) / x : 0, L = b - P + g, k = b + P + g, w = b + M + g, A = b - M + g, S = f - r, T = f + m, i.y < 0 && (S = f, T = f + m + r), t.inverted && (v = a.width - f, x = C - (a.width - p), P = g * (C - v) / x, M = g * (C - (v - m)) / x, k = (L = b + g + P) - 2 * P, w = b - M + g, A = b + M + g, S = f, T = f + m - r, i.y < 0 && (T = f + m + r)), i.shapeType = "path", i.shapeArgs = {
          x: L,
          y: S,
          width: k - L,
          height: m,
          d: [["M", L, S], ["L", k, S], ["L", w, T], ["L", A, T], ["Z"]]
        };
      }
    }
  }
  eA.defaultOptions = ek(ev.defaultOptions, {}), P().registerSeriesType("columnpyramid", eA);
  let {
      arearange: eS
    } = P().seriesTypes,
    {
      addEvent: eT,
      merge: eC,
      extend: eN
    } = y();
  class eX extends tL {
    getColumnMetrics() {
      return this.linkedParent && this.linkedParent.columnMetrics || tf().prototype.getColumnMetrics.call(this);
    }
    drawDataLabels() {
      let t = this.pointValKey;
      if (eS) for (let e of (eS.prototype.drawDataLabels.call(this), this.points)) e.y = e[t];
    }
    toYData(t) {
      return [t.low, t.high];
    }
  }
  eX.defaultOptions = eC(tL.defaultOptions, {
    color: "#000000",
    grouping: !1,
    linkedTo: ":previous",
    tooltip: {
      pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>"
    },
    whiskerWidth: null
  }), eT(eX, "afterTranslate", function () {
    for (let t of (this || _global).points) t.plotLow = t.plotY;
  }, {
    order: 0
  }), eN(eX.prototype, {
    pointArrayMap: ["low", "high"],
    pointValKey: "high",
    doQuartiles: !1
  }), P().registerSeriesType("errorbar", eX);
  let {
      series: {
        prototype: {
          pointClass: eY
        }
      }
    } = P(),
    {
      noop: eR
    } = y(),
    {
      series: eI,
      seriesTypes: {
        column: eE
      }
    } = P(),
    {
      clamp: eD,
      isNumber: ez,
      extend: eO,
      merge: eH,
      pick: eB,
      pInt: eW,
      defined: eF
    } = y();
  class eG extends eI {
    translate() {
      let t = this.yAxis,
        e = this.options,
        i = t.center;
      this.generatePoints(), this.points.forEach(s => {
        let a = eH(e.dial, s.dial),
          o = eW(a.radius) * i[2] / 200,
          r = eW(a.baseLength) * o / 100,
          n = eW(a.rearLength) * o / 100,
          l = a.baseWidth,
          h = a.topWidth,
          p = e.overshoot,
          d = t.startAngleRad + t.translate(s.y, void 0, void 0, void 0, !0);
        (ez(p) || !1 === e.wrap) && (p = ez(p) ? p / 180 * Math.PI : 0, d = eD(d, t.startAngleRad - p, t.endAngleRad + p)), d = 180 * d / Math.PI, s.shapeType = "path", s.shapeArgs = {
          d: a.path || [["M", -n, -l / 2], ["L", r, -l / 2], ["L", o, -h / 2], ["L", o, h / 2], ["L", r, l / 2], ["L", -n, l / 2], ["Z"]],
          translateX: i[0],
          translateY: i[1],
          rotation: d
        }, s.plotX = i[0], s.plotY = i[1], eF(s.y) && t.max - t.min && (s.percentage = (s.y - t.min) / (t.max - t.min) * 100);
      });
    }
    drawPoints() {
      let t = this,
        e = t.chart,
        i = t.yAxis.center,
        s = t.pivot,
        a = t.options,
        o = a.pivot,
        r = e.renderer;
      t.points.forEach(i => {
        let s = i.graphic,
          o = i.shapeArgs,
          n = o.d,
          l = eH(a.dial, i.dial);
        s ? (s.animate(o), o.d = n) : i.graphic = r[i.shapeType](o).addClass("highcharts-dial").add(t.group), e.styledMode || i.graphic[s ? "animate" : "attr"]({
          stroke: l.borderColor,
          "stroke-width": l.borderWidth,
          fill: l.backgroundColor
        });
      }), s ? s.animate({
        translateX: i[0],
        translateY: i[1]
      }) : o && (t.pivot = r.circle(0, 0, o.radius).attr({
        zIndex: 2
      }).addClass("highcharts-pivot").translate(i[0], i[1]).add(t.group), e.styledMode || t.pivot.attr({
        fill: o.backgroundColor,
        stroke: o.borderColor,
        "stroke-width": o.borderWidth
      }));
    }
    animate(t) {
      let e = this;
      t || e.points.forEach(t => {
        let i = t.graphic;
        i && (i.attr({
          rotation: 180 * e.yAxis.startAngleRad / Math.PI
        }), i.animate({
          rotation: t.shapeArgs.rotation
        }, e.options.animation));
      });
    }
    render() {
      this.group = this.plotGroup("group", "series", this.visible ? "inherit" : "hidden", this.options.zIndex, this.chart.seriesGroup), eI.prototype.render.call(this), this.group.clip(this.chart.clipRect);
    }
    setData(t, e) {
      eI.prototype.setData.call(this, t, !1), this.processData(), this.generatePoints(), eB(e, !0) && this.chart.redraw();
    }
    hasData() {
      return !!this.points.length;
    }
  }
  eG.defaultOptions = eH(eI.defaultOptions, {
    dataLabels: {
      borderColor: "#cccccc",
      borderRadius: 3,
      borderWidth: 1,
      crop: !1,
      defer: !1,
      enabled: !0,
      verticalAlign: "top",
      y: 15,
      zIndex: 2
    },
    dial: {
      backgroundColor: "#000000",
      baseLength: "70%",
      baseWidth: 3,
      borderColor: "#cccccc",
      borderWidth: 0,
      radius: "80%",
      rearLength: "10%",
      topWidth: 1
    },
    pivot: {
      radius: 5,
      borderWidth: 0,
      borderColor: "#cccccc",
      backgroundColor: "#000000"
    },
    tooltip: {
      headerFormat: ""
    },
    showInLegend: !1
  }), eO(eG.prototype, {
    angular: !0,
    directTouch: !0,
    drawGraph: eR,
    drawTracker: eE.prototype.drawTracker,
    fixedBox: !0,
    forceDL: !0,
    noSharedTooltip: !0,
    pointClass: class extends eY {
      setState(t) {
        this.state = t;
      }
    },
    trackerGroups: ["group", "dataLabelsGroup"]
  }), P().registerSeriesType("gauge", eG);
  var eq = f(620),
    eV = f.n(eq);
  let {
      composed: e_
    } = y(),
    {
      addEvent: eU,
      pushUnique: eK
    } = y();
  function ej() {
    let t,
      e,
      i,
      s,
      a = this || _global;
    a.container && (t = eU(a.container, "mousedown", t => {
      e && e(), i && i(), (s = a.hoverPoint) && s.series && s.series.hasDraggableNodes && s.series.options.draggable && (s.series.onMouseDown(s, t), e = eU(a.container, "mousemove", t => s && s.series && s.series.onMouseMove(s, t)), i = eU(a.container.ownerDocument, "mouseup", t => (e(), i(), s && s.series && s.series.onMouseUp(s, t))));
    })), eU(a, "destroy", function () {
      t();
    });
  }
  let eZ = {
      compose: function (t) {
        eK(e_, "DragNodes") && eU(t, "load", ej);
      },
      onMouseDown: function (t, e) {
        let {
          panKey: i
        } = (this || _global).chart.options.chart;
        if (i && e[`${i}Key`]) return;
        let s = (this || _global).chart.pointer?.normalize(e) || e;
        t.fixedPosition = {
          chartX: s.chartX,
          chartY: s.chartY,
          plotX: t.plotX,
          plotY: t.plotY
        }, t.inDragMode = !0;
      },
      onMouseMove: function (t, e) {
        if (t.fixedPosition && t.inDragMode) {
          let i,
            s,
            a = (this || _global).chart,
            o = a.pointer?.normalize(e) || e,
            r = t.fixedPosition.chartX - o.chartX,
            n = t.fixedPosition.chartY - o.chartY,
            l = a.graphLayoutsLookup;
          (Math.abs(r) > 5 || Math.abs(n) > 5) && (i = t.fixedPosition.plotX - r, s = t.fixedPosition.plotY - n, a.isInsidePlot(i, s) && (t.plotX = i, t.plotY = s, t.hasDragged = !0, this.redrawHalo(t), l.forEach(t => {
            t.restartSimulation();
          })));
        }
      },
      onMouseUp: function (t) {
        t.fixedPosition && (t.hasDragged && ((this || _global).layout.enableSimulation ? (this || _global).layout.start() : (this || _global).chart.redraw()), t.inDragMode = t.hasDragged = !1, (this || _global).options.fixedDraggable || delete t.fixedPosition);
      },
      redrawHalo: function (t) {
        t && (this || _global).halo && (this || _global).halo.attr({
          d: t.haloPath((this || _global).options.states.hover.halo.size)
        });
      }
    },
    {
      setAnimation: e$
    } = y(),
    {
      composed: eQ
    } = y(),
    {
      addEvent: eJ,
      pushUnique: e0
    } = y();
  function e1() {
    (this || _global).graphLayoutsLookup && ((this || _global).graphLayoutsLookup.forEach(t => {
      t.updateSimulation();
    }), this.redraw());
  }
  function e2() {
    (this || _global).graphLayoutsLookup && ((this || _global).graphLayoutsLookup.forEach(t => {
      t.updateSimulation(!1);
    }), this.redraw());
  }
  function e3() {
    (this || _global).graphLayoutsLookup && (this || _global).graphLayoutsLookup.forEach(t => {
      t.stop();
    });
  }
  function e5() {
    let t,
      e = !1,
      i = i => {
        i.maxIterations-- && isFinite(i.temperature) && !i.isStable() && !i.enableSimulation && (i.beforeStep && i.beforeStep(), i.step(), t = !1, e = !0);
      };
    if ((this || _global).graphLayoutsLookup && !(this || _global).pointer?.hasDragged) {
      for (e$(!1, this || _global), (this || _global).graphLayoutsLookup.forEach(t => t.start()); !t;) t = !0, (this || _global).graphLayoutsLookup.forEach(i);
      e && (this || _global).series.forEach(t => {
        t && t.layout && t.render();
      });
    }
  }
  let e8 = {
    compose: function (t) {
      e0(eQ, "GraphLayout") && (eJ(t, "afterPrint", e1), eJ(t, "beforePrint", e2), eJ(t, "predraw", e3), eJ(t, "render", e5));
    },
    integrations: {},
    layouts: {}
  };
  var e6 = f(960),
    e9 = f.n(e6);
  let {
      seriesTypes: {
        bubble: {
          prototype: {
            pointClass: e4
          }
        }
      }
    } = P(),
    e7 = class extends e4 {
      destroy() {
        return this.series?.layout && this.series.layout.removeElementFromCollection(this, this.series.layout.nodes), tj().prototype.destroy.apply(this, arguments);
      }
      firePointEvent() {
        let t = this.series.options;
        if (this.isParentNode && t.parentNode) {
          let e = t.allowPointSelect;
          t.allowPointSelect = t.parentNode.allowPointSelect, tj().prototype.firePointEvent.apply(this, arguments), t.allowPointSelect = e;
        } else tj().prototype.firePointEvent.apply(this, arguments);
      }
      select() {
        let t = this.series.chart;
        this.isParentNode ? (t.getSelectedPoints = t.getSelectedParentNodes, tj().prototype.select.apply(this, arguments), t.getSelectedPoints = e9().prototype.getSelectedPoints) : tj().prototype.select.apply(this, arguments);
      }
      setState(t, e) {
        this?.graphic?.parentGroup?.element && super.setState(t, e);
      }
    },
    {
      isNumber: it
    } = y(),
    ie = {
      attractive: function (t, e, i) {
        let s = t.getMass(),
          a = -i.x * e * (this || _global).diffTemperature,
          o = -i.y * e * (this || _global).diffTemperature;
        t.fromNode.fixedPosition || (t.fromNode.plotX -= a * s.fromNode / t.fromNode.degree, t.fromNode.plotY -= o * s.fromNode / t.fromNode.degree), t.toNode.fixedPosition || (t.toNode.plotX += a * s.toNode / t.toNode.degree, t.toNode.plotY += o * s.toNode / t.toNode.degree);
      },
      attractiveForceFunction: function (t, e) {
        return (e - t) / t;
      },
      barycenter: function () {
        let t = (this || _global).options.gravitationalConstant || 0,
          e = ((this || _global).barycenter.xFactor - ((this || _global).box.left + (this || _global).box.width) / 2) * t,
          i = ((this || _global).barycenter.yFactor - ((this || _global).box.top + (this || _global).box.height) / 2) * t;
        (this || _global).nodes.forEach(function (t) {
          t.fixedPosition || (t.plotX -= e / t.mass / t.degree, t.plotY -= i / t.mass / t.degree);
        });
      },
      getK: function (t) {
        return Math.pow(t.box.width * t.box.height / t.nodes.length, 0.5);
      },
      integrate: function (t, e) {
        let i = -t.options.friction,
          s = t.options.maxSpeed,
          a = e.prevX,
          o = e.prevY,
          r = (e.plotX + e.dispX - a) * i,
          n = (e.plotY + e.dispY - o) * i,
          l = Math.abs,
          h = l(r) / (r || 1),
          p = l(n) / (n || 1),
          d = h * Math.min(s, Math.abs(r)),
          c = p * Math.min(s, Math.abs(n));
        e.prevX = e.plotX + e.dispX, e.prevY = e.plotY + e.dispY, e.plotX += d, e.plotY += c, e.temperature = t.vectorLength({
          x: d,
          y: c
        });
      },
      repulsive: function (t, e, i) {
        let s = e * (this || _global).diffTemperature / t.mass / t.degree;
        t.fixedPosition || (t.plotX += i.x * s, t.plotY += i.y * s);
      },
      repulsiveForceFunction: function (t, e) {
        return (e - t) / t * (e > t);
      }
    },
    {
      noop: ii
    } = y(),
    is = {
      barycenter: function () {
        let t,
          e,
          i = (this || _global).options.gravitationalConstant || 0,
          s = (this || _global).box,
          a = (this || _global).nodes,
          o = Math.sqrt(a.length);
        for (let r of a) if (!r.fixedPosition) {
          let a = r.mass * o,
            n = r.plotX || 0,
            l = r.plotY || 0,
            h = r.series,
            p = h.parentNode;
          this.resolveSplitSeries(r) && p && !r.isParentNode ? (t = p.plotX || 0, e = p.plotY || 0) : (t = s.width / 2, e = s.height / 2), r.plotX = n - (n - t) * i / a, r.plotY = l - (l - e) * i / a, h.chart.hoverPoint === r && h.redrawHalo && h.halo && h.redrawHalo(r);
        }
      },
      getK: ii,
      integrate: ie.integrate,
      repulsive: function (t, e, i, s) {
        let a = e * (this || _global).diffTemperature / t.mass / t.degree,
          o = i.x * a,
          r = i.y * a;
        t.fixedPosition || (t.plotX += o, t.plotY += r), s.fixedPosition || (s.plotX -= o, s.plotY -= r);
      },
      repulsiveForceFunction: function (t, e, i, s) {
        return Math.min(t, (i.marker.radius + s.marker.radius) / 2);
      }
    },
    ia = {
      attractive: function (t, e, i, s) {
        let a = t.getMass(),
          o = i.x / s * e,
          r = i.y / s * e;
        t.fromNode.fixedPosition || (t.fromNode.dispX -= o * a.fromNode / t.fromNode.degree, t.fromNode.dispY -= r * a.fromNode / t.fromNode.degree), t.toNode.fixedPosition || (t.toNode.dispX += o * a.toNode / t.toNode.degree, t.toNode.dispY += r * a.toNode / t.toNode.degree);
      },
      attractiveForceFunction: function (t, e) {
        return t * t / e;
      },
      barycenter: function () {
        let t = (this || _global).options.gravitationalConstant,
          e = (this || _global).barycenter.xFactor,
          i = (this || _global).barycenter.yFactor;
        (this || _global).nodes.forEach(function (s) {
          if (!s.fixedPosition) {
            let a = s.getDegree(),
              o = a * (1 + a / 2);
            s.dispX += (e - s.plotX) * t * o / s.degree, s.dispY += (i - s.plotY) * t * o / s.degree;
          }
        });
      },
      getK: function (t) {
        return Math.pow(t.box.width * t.box.height / t.nodes.length, 0.3);
      },
      integrate: function (t, e) {
        e.dispX += e.dispX * t.options.friction, e.dispY += e.dispY * t.options.friction;
        let i = e.temperature = t.vectorLength({
          x: e.dispX,
          y: e.dispY
        });
        0 !== i && (e.plotX += e.dispX / i * Math.min(Math.abs(e.dispX), t.temperature), e.plotY += e.dispY / i * Math.min(Math.abs(e.dispY), t.temperature));
      },
      repulsive: function (t, e, i, s) {
        t.dispX += i.x / s * e / t.degree, t.dispY += i.y / s * e / t.degree;
      },
      repulsiveForceFunction: function (t, e) {
        return e * e / t;
      }
    };
  class io {
    constructor(t) {
      this.body = !1, this.isEmpty = !1, this.isInternal = !1, this.nodes = [], this.box = t, this.boxSize = Math.min(t.width, t.height);
    }
    divideBox() {
      let t = this.box.width / 2,
        e = this.box.height / 2;
      this.nodes[0] = new io({
        left: this.box.left,
        top: this.box.top,
        width: t,
        height: e
      }), this.nodes[1] = new io({
        left: this.box.left + t,
        top: this.box.top,
        width: t,
        height: e
      }), this.nodes[2] = new io({
        left: this.box.left + t,
        top: this.box.top + e,
        width: t,
        height: e
      }), this.nodes[3] = new io({
        left: this.box.left,
        top: this.box.top + e,
        width: t,
        height: e
      });
    }
    getBoxPosition(t) {
      let e = t.plotX < this.box.left + this.box.width / 2,
        i = t.plotY < this.box.top + this.box.height / 2;
      return e ? 3 * !i : i ? 1 : 2;
    }
    insert(t, e) {
      let i;
      this.isInternal ? this.nodes[this.getBoxPosition(t)].insert(t, e - 1) : (this.isEmpty = !1, this.body ? e ? (this.isInternal = !0, this.divideBox(), !0 !== this.body && (this.nodes[this.getBoxPosition(this.body)].insert(this.body, e - 1), this.body = !0), this.nodes[this.getBoxPosition(t)].insert(t, e - 1)) : ((i = new io({
        top: t.plotX || NaN,
        left: t.plotY || NaN,
        width: 0.1,
        height: 0.1
      })).body = t, i.isInternal = !1, this.nodes.push(i)) : (this.isInternal = !1, this.body = t));
    }
    updateMassAndCenter() {
      let t = 0,
        e = 0,
        i = 0;
      if (this.isInternal) {
        for (let s of this.nodes) s.isEmpty || (t += s.mass, e += s.plotX * s.mass, i += s.plotY * s.mass);
        e /= t, i /= t;
      } else this.body && (t = this.body.mass, e = this.body.plotX, i = this.body.plotY);
      this.mass = t, this.plotX = e, this.plotY = i;
    }
  }
  let ir = class {
      constructor(t, e, i, s) {
        this.box = {
          left: t,
          top: e,
          width: i,
          height: s
        }, this.maxDepth = 25, this.root = new io(this.box), this.root.isInternal = !0, this.root.isRoot = !0, this.root.divideBox();
      }
      calculateMassAndCenter() {
        this.visitNodeRecursive(null, null, function (t) {
          t.updateMassAndCenter();
        });
      }
      insertNodes(t) {
        for (let e of t) this.root.insert(e, this.maxDepth);
      }
      visitNodeRecursive(t, e, i) {
        let s;
        if (t || (t = this.root), t === this.root && e && (s = e(t)), !1 !== s) {
          for (let a of t.nodes) {
            if (a.isInternal) {
              if (e && (s = e(a)), !1 === s) continue;
              this.visitNodeRecursive(a, e, i);
            } else a.body && e && e(a.body);
            i && i(a);
          }
          t === this.root && i && i(t);
        }
      }
    },
    {
      win: il
    } = y(),
    {
      clamp: ih,
      defined: ip,
      isFunction: id,
      fireEvent: ic,
      pick: iu
    } = y();
  class ig {
    constructor() {
      this.box = {}, this.currentStep = 0, this.initialRendering = !0, this.links = [], this.nodes = [], this.series = [], this.simulation = !1;
    }
    static compose(t) {
      e8.compose(t), e8.integrations.euler = ia, e8.integrations.verlet = ie, e8.layouts["reingold-fruchterman"] = ig;
    }
    init(t) {
      this.options = t, this.nodes = [], this.links = [], this.series = [], this.box = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }, this.setInitialRendering(!0), this.integration = e8.integrations[t.integration], this.enableSimulation = t.enableSimulation, this.attractiveForce = iu(t.attractiveForce, this.integration.attractiveForceFunction), this.repulsiveForce = iu(t.repulsiveForce, this.integration.repulsiveForceFunction), this.approximation = t.approximation;
    }
    updateSimulation(t) {
      this.enableSimulation = iu(t, this.options.enableSimulation);
    }
    start() {
      let t = this.series,
        e = this.options;
      this.currentStep = 0, this.forces = t[0] && t[0].forces || [], this.chart = t[0] && t[0].chart, this.initialRendering && (this.initPositions(), t.forEach(function (t) {
        t.finishedAnimating = !0, t.render();
      })), this.setK(), this.resetSimulation(e), this.enableSimulation && this.step();
    }
    step() {
      let t = this.series;
      for (let t of (this.currentStep++, "barnes-hut" === this.approximation && (this.createQuadTree(), this.quadTree.calculateMassAndCenter()), this.forces || [])) this[t + "Forces"](this.temperature);
      if (this.applyLimits(), this.temperature = this.coolDown(this.startTemperature, this.diffTemperature, this.currentStep), this.prevSystemTemperature = this.systemTemperature, this.systemTemperature = this.getSystemTemperature(), this.enableSimulation) {
        for (let e of t) e.chart && e.render();
        this.maxIterations-- && isFinite(this.temperature) && !this.isStable() ? (this.simulation && il.cancelAnimationFrame(this.simulation), this.simulation = il.requestAnimationFrame(() => this.step())) : (this.simulation = !1, this.series.forEach(t => {
          ic(t, "afterSimulation");
        }));
      }
    }
    stop() {
      this.simulation && il.cancelAnimationFrame(this.simulation);
    }
    setArea(t, e, i, s) {
      this.box = {
        left: t,
        top: e,
        width: i,
        height: s
      };
    }
    setK() {
      this.k = this.options.linkLength || this.integration.getK(this);
    }
    addElementsToCollection(t, e) {
      for (let i of t) -1 === e.indexOf(i) && e.push(i);
    }
    removeElementFromCollection(t, e) {
      let i = e.indexOf(t);
      -1 !== i && e.splice(i, 1);
    }
    clear() {
      this.nodes.length = 0, this.links.length = 0, this.series.length = 0, this.resetSimulation();
    }
    resetSimulation() {
      this.forcedStop = !1, this.systemTemperature = 0, this.setMaxIterations(), this.setTemperature(), this.setDiffTemperature();
    }
    restartSimulation() {
      this.simulation ? this.resetSimulation() : (this.setInitialRendering(!1), this.enableSimulation ? this.start() : this.setMaxIterations(1), this.chart && this.chart.redraw(), this.setInitialRendering(!0));
    }
    setMaxIterations(t) {
      this.maxIterations = iu(t, this.options.maxIterations);
    }
    setTemperature() {
      this.temperature = this.startTemperature = Math.sqrt(this.nodes.length);
    }
    setDiffTemperature() {
      this.diffTemperature = this.startTemperature / (this.options.maxIterations + 1);
    }
    setInitialRendering(t) {
      this.initialRendering = t;
    }
    createQuadTree() {
      this.quadTree = new ir(this.box.left, this.box.top, this.box.width, this.box.height), this.quadTree.insertNodes(this.nodes);
    }
    initPositions() {
      let t = this.options.initialPositions;
      if (id(t)) for (let e of (t.call(this), this.nodes)) ip(e.prevX) || (e.prevX = e.plotX), ip(e.prevY) || (e.prevY = e.plotY), e.dispX = 0, e.dispY = 0;else "circle" === t ? this.setCircularPositions() : this.setRandomPositions();
    }
    setCircularPositions() {
      let t,
        e = this.box,
        i = this.nodes,
        s = 2 * Math.PI / (i.length + 1),
        a = i.filter(function (t) {
          return 0 === t.linksTo.length;
        }),
        o = {},
        r = this.options.initialPositionRadius,
        n = t => {
          for (let e of t.linksFrom || []) o[e.toNode.id] || (o[e.toNode.id] = !0, l.push(e.toNode), n(e.toNode));
        },
        l = [];
      for (let t of a) l.push(t), n(t);
      if (l.length) for (let t of i) -1 === l.indexOf(t) && l.push(t);else l = i;
      for (let i = 0, a = l.length; i < a; ++i) (t = l[i]).plotX = t.prevX = iu(t.plotX, e.width / 2 + r * Math.cos(i * s)), t.plotY = t.prevY = iu(t.plotY, e.height / 2 + r * Math.sin(i * s)), t.dispX = 0, t.dispY = 0;
    }
    setRandomPositions() {
      let t,
        e = this.box,
        i = this.nodes,
        s = i.length + 1,
        a = t => {
          let e = t * t / Math.PI;
          return e - Math.floor(e);
        };
      for (let o = 0, r = i.length; o < r; ++o) (t = i[o]).plotX = t.prevX = iu(t.plotX, e.width * a(o)), t.plotY = t.prevY = iu(t.plotY, e.height * a(s + o)), t.dispX = 0, t.dispY = 0;
    }
    force(t, ...e) {
      this.integration[t].apply(this, e);
    }
    barycenterForces() {
      this.getBarycenter(), this.force("barycenter");
    }
    getBarycenter() {
      let t = 0,
        e = 0,
        i = 0;
      for (let s of this.nodes) e += s.plotX * s.mass, i += s.plotY * s.mass, t += s.mass;
      return this.barycenter = {
        x: e,
        y: i,
        xFactor: e / t,
        yFactor: i / t
      }, this.barycenter;
    }
    barnesHutApproximation(t, e) {
      let i,
        s,
        a = this.getDistXY(t, e),
        o = this.vectorLength(a);
      return t !== e && 0 !== o && (e.isInternal ? e.boxSize / o < this.options.theta && 0 !== o ? (s = this.repulsiveForce(o, this.k), this.force("repulsive", t, s * e.mass, a, o), i = !1) : i = !0 : (s = this.repulsiveForce(o, this.k), this.force("repulsive", t, s * e.mass, a, o))), i;
    }
    repulsiveForces() {
      if ("barnes-hut" === this.approximation) for (let t of this.nodes) this.quadTree.visitNodeRecursive(null, e => this.barnesHutApproximation(t, e));else {
        let t, e, i;
        for (let s of this.nodes) for (let a of this.nodes) s === a || s.fixedPosition || (i = this.getDistXY(s, a), 0 !== (e = this.vectorLength(i)) && (t = this.repulsiveForce(e, this.k), this.force("repulsive", s, t * a.mass, i, e)));
      }
    }
    attractiveForces() {
      let t, e, i;
      for (let s of this.links) s.fromNode && s.toNode && (t = this.getDistXY(s.fromNode, s.toNode), 0 !== (e = this.vectorLength(t)) && (i = this.attractiveForce(e, this.k), this.force("attractive", s, i, t, e)));
    }
    applyLimits() {
      for (let t of this.nodes) t.fixedPosition || (this.integration.integrate(this, t), this.applyLimitBox(t, this.box), t.dispX = 0, t.dispY = 0);
    }
    applyLimitBox(t, e) {
      let i = t.radius;
      t.plotX = ih(t.plotX, e.left + i, e.width - i), t.plotY = ih(t.plotY, e.top + i, e.height - i);
    }
    coolDown(t, e, i) {
      return t - e * i;
    }
    isStable() {
      return 0.00001 > Math.abs(this.systemTemperature - this.prevSystemTemperature) || this.temperature <= 0;
    }
    getSystemTemperature() {
      let t = 0;
      for (let e of this.nodes) t += e.temperature;
      return t;
    }
    vectorLength(t) {
      return Math.sqrt(t.x * t.x + t.y * t.y);
    }
    getDistR(t, e) {
      let i = this.getDistXY(t, e);
      return this.vectorLength(i);
    }
    getDistXY(t, e) {
      let i = t.plotX - e.plotX,
        s = t.plotY - e.plotY;
      return {
        x: i,
        y: s,
        absX: Math.abs(i),
        absY: Math.abs(s)
      };
    }
  }
  let im = ig,
    {
      addEvent: ib,
      defined: iy,
      pick: ix
    } = y();
  function iP() {
    let t = (this || _global).series,
      e = [];
    return t.forEach(t => {
      t.parentNode && t.parentNode.selected && e.push(t.parentNode);
    }), e;
  }
  function iM() {
    (this || _global).allDataPoints && delete (this || _global).allDataPoints;
  }
  class iv extends im {
    constructor() {
      super(...arguments), this.index = NaN, this.nodes = [], this.series = [];
    }
    static compose(t) {
      im.compose(t), e8.integrations.packedbubble = is, e8.layouts.packedbubble = iv;
      let e = t.prototype;
      e.getSelectedParentNodes || (ib(t, "beforeRedraw", iM), e.getSelectedParentNodes = iP), e.allParentNodes || (e.allParentNodes = []);
    }
    beforeStep() {
      this.options.marker && this.series.forEach(t => {
        t && t.calculateParentRadius();
      });
    }
    isStable() {
      let t = Math.abs(this.prevSystemTemperature - this.systemTemperature);
      return 1 > Math.abs(10 * this.systemTemperature / Math.sqrt(this.nodes.length)) && t < 0.00001 || this.temperature <= 0;
    }
    setCircularPositions() {
      let t = this.box,
        e = [...this.nodes, ...(this?.chart?.allParentNodes || [])],
        i = 2 * Math.PI / (e.length + 1),
        s = this.options.initialPositionRadius,
        a,
        o,
        r = 0;
      for (let n of e) this.resolveSplitSeries(n) && !n.isParentNode ? (a = n.series.parentNode.plotX, o = n.series.parentNode.plotY) : (a = t.width / 2, o = t.height / 2), n.plotX = n.prevX = ix(n.plotX, a + s * Math.cos(n.index || r * i)), n.plotY = n.prevY = ix(n.plotY, o + s * Math.sin(n.index || r * i)), n.dispX = 0, n.dispY = 0, r++;
    }
    repulsiveForces() {
      let {
          options: t,
          k: e
        } = this,
        {
          bubblePadding: i = 0,
          seriesInteraction: s
        } = t,
        a = [...this.nodes, ...(this?.chart?.allParentNodes || [])];
      for (let t of a) {
        let o = t.series,
          r = t.fixedPosition,
          n = (t.marker?.radius || 0) + i;
        for (let i of (t.degree = t.mass, t.neighbours = 0, a)) {
          let a = i.series;
          if (t !== i && !r && (s || o === a) && !(o === a && (i.isParentNode || t.isParentNode))) {
            let s,
              a = this.getDistXY(t, i),
              o = this.vectorLength(a) - (n + (i.marker?.radius || 0));
            o < 0 && (t.degree += 0.01, s = this.repulsiveForce(-o / Math.sqrt(++t.neighbours), e, t, i) * i.mass), this.force("repulsive", t, s || 0, a, i, o);
          }
        }
      }
    }
    resolveSplitSeries(t) {
      let e = t.series?.options?.layoutAlgorithm?.splitSeries;
      return !iy(e) && t.series.chart?.options?.plotOptions?.packedbubble?.layoutAlgorithm?.splitSeries || e || !1;
    }
    applyLimitBox(t, e) {
      let i, s;
      this.resolveSplitSeries(t) && !t.isParentNode && this.options.parentNodeLimit && (i = this.getDistXY(t, t.series.parentNode), (s = t.series.parentNodeRadius - t.marker.radius - this.vectorLength(i)) < 0 && s > -2 * t.marker.radius && (t.plotX -= 0.01 * i.x, t.plotY -= 0.01 * i.y)), super.applyLimitBox(t, e);
    }
  }
  e8.layouts.packedbubble = iv;
  let {
      merge: iL,
      syncTimeout: ik
    } = y(),
    {
      animObject: iw
    } = y();
  var iA = f(28),
    iS = f.n(iA);
  let {
      deg2rad: iT
    } = y(),
    {
      addEvent: iC,
      merge: iN,
      uniqueKey: iX,
      defined: iY,
      extend: iR
    } = y();
  function iI(t, e) {
    e = iN(!0, {
      enabled: !0,
      attributes: {
        dy: -5,
        startOffset: "50%",
        textAnchor: "middle"
      }
    }, e);
    let i = (this || _global).renderer.url,
      s = (this || _global).text || this || _global,
      a = s.textPath,
      {
        attributes: o,
        enabled: r
      } = e;
    if (t = t || a && a.path, a && a.undo(), t && r) {
      let e = iC(s, "afterModifyTree", e => {
        if (t && r) {
          let a = t.attr("id");
          a || t.attr("id", a = iX());
          let r = {
            x: 0,
            y: 0
          };
          iY(o.dx) && (r.dx = o.dx, delete o.dx), iY(o.dy) && (r.dy = o.dy, delete o.dy), s.attr(r), this.attr({
            transform: ""
          }), (this || _global).box && ((this || _global).box = (this || _global).box.destroy());
          let n = e.nodes.slice(0);
          e.nodes.length = 0, e.nodes[0] = {
            tagName: "textPath",
            attributes: iR(o, {
              "text-anchor": o.textAnchor,
              href: `${i}#${a}`
            }),
            children: n
          };
        }
      });
      s.textPath = {
        path: t,
        undo: e
      };
    } else s.attr({
      dx: 0,
      dy: 0
    }), delete s.textPath;
    return (this || _global).added && (s.textCache = "", (this || _global).renderer.buildText(s)), this || _global;
  }
  function iE(t) {
    let e = t.bBox,
      i = (this || _global).element?.querySelector("textPath");
    if (i) {
      let t = [],
        {
          b: s,
          h: a
        } = (this || _global).renderer.fontMetrics((this || _global).element),
        o = a - s,
        r = RegExp("(<tspan>|<tspan(?!\\sclass=\"highcharts-br\")[^>]*>|<\\/tspan>)", "g"),
        n = i.innerHTML.replace(r, "").split(/<tspan class="highcharts-br"[^>]*>/),
        l = n.length,
        h = (t, e) => {
          let {
              x: a,
              y: r
            } = e,
            n = (i.getRotationOfChar(t) - 90) * iT,
            l = Math.cos(n),
            h = Math.sin(n);
          return [[a - o * l, r - o * h], [a + s * l, r + s * h]];
        };
      for (let e = 0, s = 0; s < l; s++) {
        let a = n[s].length;
        for (let o = 0; o < a; o += 5) try {
          let a = e + o + s,
            [r, n] = h(a, i.getStartPositionOfChar(a));
          0 === o ? (t.push(n), t.push(r)) : (0 === s && t.unshift(n), s === l - 1 && t.push(r));
        } catch {
          break;
        }
        e += a - 1;
        try {
          let a = e + s,
            o = i.getEndPositionOfChar(a),
            [r, n] = h(a, o);
          t.unshift(n), t.unshift(r);
        } catch {
          break;
        }
      }
      t.length && t.push(t[0].slice()), e.polygon = t;
    }
    return e;
  }
  function iD(t) {
    let e = t.labelOptions,
      i = t.point,
      s = e[i.formatPrefix + "TextPath"] || e.textPath;
    s && !e.useHTML && (this.setTextPath(i.getDataLabelPath?.(this || _global) || i.graphic, s), i.dataLabelPath && !s.enabled && (i.dataLabelPath = i.dataLabelPath.destroy()));
  }
  let {
      parse: iz
    } = eV(),
    {
      noop: iO
    } = y(),
    {
      series: {
        prototype: iH
      },
      seriesTypes: {
        bubble: iB
      }
    } = P(),
    {
      initDataLabels: iW,
      initDataLabelsDefer: iF
    } = {
      initDataLabels: function () {
        let t = (this || _global).options.dataLabels;
        if (!(this || _global).dataLabelsGroup) {
          let e = this.initDataLabelsGroup();
          return !(this || _global).chart.styledMode && t?.style && e.css(t.style), e.attr({
            opacity: 0
          }), (this || _global).visible && ((this || _global).options.animation && t?.animation ? e.animate({
            opacity: 1
          }, t?.animation) : e.attr({
            opacity: 1
          }), e.show()), e;
        }
        return (this || _global).dataLabelsGroup.attr(iL({
          opacity: 1
        }, this.getPlotBox("data-labels"))), (this || _global).dataLabelsGroup;
      },
      initDataLabelsDefer: function () {
        let t = (this || _global).options.dataLabels;
        t?.defer && (this || _global).options.layoutAlgorithm?.enableSimulation ? ik(() => {
          (this || _global).deferDataLabels = !1;
        }, t ? iw(t.animation).defer : 0) : (this || _global).deferDataLabels = !1;
      }
    },
    {
      addEvent: iG,
      clamp: iq,
      defined: iV,
      extend: i_,
      fireEvent: iU,
      isArray: iK,
      isNumber: ij,
      merge: iZ,
      pick: i$
    } = y();
  ({
    compose: function (t) {
      iC(t, "afterGetBBox", iE), iC(t, "beforeAddingDataLabel", iD);
      let e = t.prototype;
      e.setTextPath || (e.setTextPath = iI);
    }
  }).compose(iS());
  class iQ extends iB {
    constructor() {
      super(...arguments), this.parentNodeMass = 0, this.deferDataLabels = !0;
    }
    static compose(t, e, i) {
      iB.compose(t, e, i), eZ.compose(e), iv.compose(e);
    }
    accumulateAllPoints() {
      let t = this.chart,
        e = [];
      for (let i of t.series) if (i.is("packedbubble") && i.reserveSpace()) {
        let t = i.getColumn("value");
        for (let s = 0; s < t.length; s++) e.push([null, null, t[s], i.index, s, {
          id: s,
          marker: {
            radius: 0
          }
        }]);
      }
      return e;
    }
    addLayout() {
      let t = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {},
        e = t.type || "packedbubble",
        i = this.chart.options.chart,
        s = this.chart.graphLayoutsStorage,
        a = this.chart.graphLayoutsLookup,
        o;
      s || (this.chart.graphLayoutsStorage = s = {}, this.chart.graphLayoutsLookup = a = []), (o = s[e]) || (t.enableSimulation = iV(i.forExport) ? !i.forExport : t.enableSimulation, s[e] = o = new e8.layouts[e](), o.init(t), a.splice(o.index, 0, o)), this.layout = o, this.points.forEach(t => {
        t.mass = 2, t.degree = 1, t.collisionNmb = 1;
      }), o.setArea(0, 0, this.chart.plotWidth, this.chart.plotHeight), o.addElementsToCollection([this], o.series), o.addElementsToCollection(this.points, o.nodes);
    }
    addSeriesLayout() {
      let t = this.options.layoutAlgorithm = this.options.layoutAlgorithm || {},
        e = t.type || "packedbubble",
        i = this.chart.graphLayoutsStorage,
        s = this.chart.graphLayoutsLookup,
        a = iZ(t, t.parentNodeOptions, {
          enableSimulation: this.layout.options.enableSimulation
        }),
        o = i[e + "-series"];
      o || (i[e + "-series"] = o = new e8.layouts[e](), o.init(a), s.splice(o.index, 0, o)), this.parentNodeLayout = o, this.createParentNodes();
    }
    calculateParentRadius() {
      let t = this.seriesBox();
      this.parentNodeRadius = iq(Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20, 20, t ? Math.max(Math.sqrt(Math.pow(t.width, 2) + Math.pow(t.height, 2)) / 2 + 20, 20) : Math.sqrt(2 * this.parentNodeMass / Math.PI) + 20), this.parentNode && (this.parentNode.marker.radius = this.parentNode.radius = this.parentNodeRadius);
    }
    calculateZExtremes() {
      let t = this.chart.series,
        e = this.options.zMin,
        i = this.options.zMax,
        s = 1 / 0,
        a = -1 / 0;
      return e && i ? [e, i] : (t.forEach(t => {
        t.getColumn("value").forEach(t => {
          iV(t) && (t > a && (a = t), t < s && (s = t));
        });
      }), [e = i$(e, s), i = i$(i, a)]);
    }
    checkOverlap(t, e) {
      let i = t[0] - e[0],
        s = t[1] - e[1];
      return Math.sqrt(i * i + s * s) - Math.abs(t[2] + e[2]) < -0.001;
    }
    createParentNodes() {
      let t = this.pointClass,
        e = this.chart,
        i = this.parentNodeLayout,
        s = this.layout.options,
        a,
        o = this.parentNode,
        r = {
          radius: this.parentNodeRadius,
          lineColor: this.color,
          fillColor: iz(this.color).brighten(0.4).get()
        };
      s.parentNodeOptions && (r = iZ(s.parentNodeOptions.marker || {}, r)), this.parentNodeMass = 0, this.points.forEach(t => {
        this.parentNodeMass += Math.PI * Math.pow(t.marker.radius, 2);
      }), this.calculateParentRadius(), i.nodes.forEach(t => {
        t.seriesIndex === this.index && (a = !0);
      }), i.setArea(0, 0, e.plotWidth, e.plotHeight), a || (o || (o = new t(this, {
        mass: this.parentNodeRadius / 2,
        marker: r,
        dataLabels: {
          inside: !1
        },
        states: {
          normal: {
            marker: r
          },
          hover: {
            marker: r
          }
        },
        dataLabelOnNull: !0,
        degree: this.parentNodeRadius,
        isParentNode: !0,
        seriesIndex: this.index
      }), this.chart.allParentNodes.push(o)), this.parentNode && (o.plotX = this.parentNode.plotX, o.plotY = this.parentNode.plotY), this.parentNode = o, i.addElementsToCollection([this], i.series), i.addElementsToCollection([o], i.nodes));
    }
    deferLayout() {
      let t = this.options.layoutAlgorithm;
      this.visible && (this.addLayout(), t.splitSeries && this.addSeriesLayout());
    }
    destroy() {
      this.chart.graphLayoutsLookup && this.chart.graphLayoutsLookup.forEach(t => {
        t.removeElementFromCollection(this, t.series);
      }, this), this.parentNode && this.parentNodeLayout && (this.parentNodeLayout.removeElementFromCollection(this.parentNode, this.parentNodeLayout.nodes), this.parentNode.dataLabel && (this.parentNode.dataLabel = this.parentNode.dataLabel.destroy())), iH.destroy.apply(this, arguments);
    }
    drawDataLabels() {
      !this.deferDataLabels && (iH.drawDataLabels.call(this, this.points), this.parentNode && (this.parentNode.formatPrefix = "parentNode", iH.drawDataLabels.call(this, [this.parentNode])));
    }
    drawGraph() {
      if (!this.layout || !this.layout.options.splitSeries) return;
      let t = this.chart,
        e = this.layout.options.parentNodeOptions.marker,
        i = {
          fill: e.fillColor || iz(this.color).brighten(0.4).get(),
          opacity: e.fillOpacity,
          stroke: e.lineColor || this.color,
          "stroke-width": i$(e.lineWidth, this.options.lineWidth)
        },
        s = {};
      this.parentNodesGroup = this.plotGroup("parentNodesGroup", "parentNode", this.visible ? "inherit" : "hidden", 0.1, t.seriesGroup), this.group?.attr({
        zIndex: 2
      }), this.calculateParentRadius(), this.parentNode && iV(this.parentNode.plotX) && iV(this.parentNode.plotY) && iV(this.parentNodeRadius) && (s = iZ({
        x: this.parentNode.plotX - this.parentNodeRadius,
        y: this.parentNode.plotY - this.parentNodeRadius,
        width: 2 * this.parentNodeRadius,
        height: 2 * this.parentNodeRadius
      }, i), this.parentNode.graphic || (this.graph = this.parentNode.graphic = t.renderer.symbol(i.symbol).add(this.parentNodesGroup)), this.parentNode.graphic.attr(s));
    }
    drawTracker() {
      let t,
        e = this.parentNode;
      super.drawTracker(), e && (t = iK(e.dataLabels) ? e.dataLabels : e.dataLabel ? [e.dataLabel] : [], e.graphic && (e.graphic.element.point = e), t.forEach(t => {
        (t.div || t.element).point = e;
      }));
    }
    getPointRadius() {
      let t,
        e,
        i,
        s,
        a = this.chart,
        o = a.plotWidth,
        r = a.plotHeight,
        n = this.options,
        l = n.useSimulation,
        h = Math.min(o, r),
        p = {},
        d = [],
        c = a.allDataPoints || [],
        u = c.length;
      ["minSize", "maxSize"].forEach(t => {
        let e = parseInt(n[t], 10),
          i = /%$/.test(n[t]);
        p[t] = i ? h * e / 100 : e * Math.sqrt(u);
      }), a.minRadius = t = p.minSize / Math.sqrt(u), a.maxRadius = e = p.maxSize / Math.sqrt(u);
      let g = l ? this.calculateZExtremes() : [t, e];
      c.forEach((a, o) => {
        i = l ? iq(a[2], g[0], g[1]) : a[2], 0 === (s = this.getRadius(g[0], g[1], t, e, i)) && (s = null), c[o][2] = s, d.push(s);
      }), this.radii = d;
    }
    init() {
      return iH.init.apply(this, arguments), iF.call(this), this.eventsToUnbind.push(iG(this, "updatedData", function () {
        this.chart.series.forEach(t => {
          t.type === this.type && (t.isDirty = !0);
        }, this);
      })), this;
    }
    onMouseUp(t) {
      if (t.fixedPosition && !t.removed) {
        let e,
          i = this.layout,
          s = this.parentNodeLayout;
        !t.isParentNode && s && i.options.dragBetweenSeries && s.nodes.forEach(s => {
          t && t.marker && s !== t.series.parentNode && (e = i.getDistXY(t, s), i.vectorLength(e) - s.marker.radius - t.marker.radius < 0 && (s.series.addPoint(iZ(t.options, {
            plotX: t.plotX,
            plotY: t.plotY
          }), !1), i.removeElementFromCollection(t, i.nodes), t.remove()));
        }), eZ.onMouseUp.apply(this, arguments);
      }
    }
    placeBubbles(t) {
      let e = this.checkOverlap,
        i = this.positionBubble,
        s = [],
        a = 1,
        o = 0,
        r = 0,
        n,
        l = [],
        h,
        p = t.sort((t, e) => e[2] - t[2]);
      if (p.length) {
        if (s.push([[0, 0, p[0][2], p[0][3], p[0][4]]]), p.length > 1) for (s.push([[0, 0 - p[1][2] - p[0][2], p[1][2], p[1][3], p[1][4]]]), h = 2; h < p.length; h++) p[h][2] = p[h][2] || 1, e(n = i(s[a][o], s[a - 1][r], p[h]), s[a][0]) ? (s.push([]), r = 0, s[a + 1].push(i(s[a][o], s[a][0], p[h])), a++, o = 0) : a > 1 && s[a - 1][r + 1] && e(n, s[a - 1][r + 1]) ? (r++, s[a].push(i(s[a][o], s[a - 1][r], p[h])), o++) : (o++, s[a].push(n));
        this.chart.stages = s, this.chart.rawPositions = [].concat.apply([], s), this.resizeRadius(), l = this.chart.rawPositions;
      }
      return l;
    }
    pointAttribs(t, e) {
      let i = this.options,
        s = t && t.isParentNode,
        a = i.marker;
      s && i.layoutAlgorithm && i.layoutAlgorithm.parentNodeOptions && (a = i.layoutAlgorithm.parentNodeOptions.marker);
      let o = a.fillOpacity,
        r = iH.pointAttribs.call(this, t, e);
      return 1 !== o && (r["fill-opacity"] = o), r;
    }
    positionBubble(t, e, i) {
      let s = Math.asin,
        a = Math.acos,
        o = Math.pow,
        r = Math.abs,
        n = (0, Math.sqrt)(o(t[0] - e[0], 2) + o(t[1] - e[1], 2)),
        l = a((o(n, 2) + o(i[2] + e[2], 2) - o(i[2] + t[2], 2)) / (2 * (i[2] + e[2]) * n)),
        h = s(r(t[0] - e[0]) / n),
        p = (t[1] - e[1] < 0 ? 0 : Math.PI) + l + h * ((t[0] - e[0]) * (t[1] - e[1]) < 0 ? 1 : -1),
        d = Math.cos(p),
        c = Math.sin(p);
      return [e[0] + (e[2] + i[2]) * c, e[1] - (e[2] + i[2]) * d, i[2], i[3], i[4]];
    }
    render() {
      let t = [];
      iH.render.apply(this, arguments), !this.options.dataLabels.allowOverlap && (this.data.forEach(e => {
        iK(e.dataLabels) && e.dataLabels.forEach(e => {
          t.push(e);
        });
      }), this.options.useSimulation && this.chart.hideOverlappingLabels(t));
    }
    resizeRadius() {
      let t,
        e,
        i,
        s,
        a,
        o = this.chart,
        r = o.rawPositions,
        n = Math.min,
        l = Math.max,
        h = o.plotLeft,
        p = o.plotTop,
        d = o.plotHeight,
        c = o.plotWidth;
      for (let o of (t = i = Number.POSITIVE_INFINITY, e = s = Number.NEGATIVE_INFINITY, r)) a = o[2], t = n(t, o[0] - a), e = l(e, o[0] + a), i = n(i, o[1] - a), s = l(s, o[1] + a);
      let u = [e - t, s - i],
        g = [(c - h) / u[0], (d - p) / u[1]],
        f = n.apply([], g);
      if (Math.abs(f - 1) > 1e-10) {
        for (let t of r) t[2] *= f;
        this.placeBubbles(r);
      } else o.diffY = d / 2 + p - i - (s - i) / 2, o.diffX = c / 2 + h - t - (e - t) / 2;
    }
    seriesBox() {
      let t,
        e = this.chart,
        i = this.data,
        s = Math.max,
        a = Math.min,
        o = [e.plotLeft, e.plotLeft + e.plotWidth, e.plotTop, e.plotTop + e.plotHeight];
      return i.forEach(e => {
        iV(e.plotX) && iV(e.plotY) && e.marker.radius && (t = e.marker.radius, o[0] = a(o[0], e.plotX - t), o[1] = s(o[1], e.plotX + t), o[2] = a(o[2], e.plotY - t), o[3] = s(o[3], e.plotY + t));
      }), ij(o.width / o.height) ? o : null;
    }
    setVisible() {
      let t = this;
      iH.setVisible.apply(t, arguments), t.parentNodeLayout && t.graph ? t.visible ? (t.graph.show(), t.parentNode.dataLabel && t.parentNode.dataLabel.show()) : (t.graph.hide(), t.parentNodeLayout.removeElementFromCollection(t.parentNode, t.parentNodeLayout.nodes), t.parentNode.dataLabel && t.parentNode.dataLabel.hide()) : t.layout && (t.visible ? t.layout.addElementsToCollection(t.points, t.layout.nodes) : t.points.forEach(e => {
        t.layout.removeElementFromCollection(e, t.layout.nodes);
      }));
    }
    translate() {
      let t,
        e,
        i,
        s = this.chart,
        a = this.data,
        o = this.index,
        r = this.options.useSimulation;
      for (let n of (this.generatePoints(), iV(s.allDataPoints) || (s.allDataPoints = this.accumulateAllPoints(), this.getPointRadius()), r ? i = s.allDataPoints : (i = this.placeBubbles(s.allDataPoints), this.options.draggable = !1), i)) n[3] === o && (t = a[n[4]], e = i$(n[2], void 0), r || (t.plotX = n[0] - s.plotLeft + s.diffX, t.plotY = n[1] - s.plotTop + s.diffY), ij(e) && (t.marker = i_(t.marker, {
        radius: e,
        width: 2 * e,
        height: 2 * e
      }), t.radius = e));
      r && this.deferLayout(), iU(this, "afterTranslate");
    }
  }
  iQ.defaultOptions = iZ(iB.defaultOptions, {
    minSize: "10%",
    maxSize: "50%",
    sizeBy: "area",
    zoneAxis: "y",
    crisp: !1,
    tooltip: {
      pointFormat: "Value: {point.value}"
    },
    draggable: !0,
    useSimulation: !0,
    parentNode: {
      allowPointSelect: !1
    },
    dataLabels: {
      formatter: function () {
        let {
            numberFormatter: t
          } = (this || _global).series.chart,
          {
            value: e
          } = (this || _global).point;
        return it(e) ? t(e, -1) : "";
      },
      parentNodeFormatter: function () {
        return (this || _global).name || "";
      },
      parentNodeTextPath: {
        enabled: !0
      },
      padding: 0,
      style: {
        transition: "opacity 2000ms"
      }
    },
    layoutAlgorithm: {
      initialPositions: "circle",
      initialPositionRadius: 20,
      bubblePadding: 5,
      parentNodeLimit: !1,
      seriesInteraction: !0,
      dragBetweenSeries: !1,
      parentNodeOptions: {
        maxIterations: 400,
        gravitationalConstant: 0.03,
        maxSpeed: 50,
        initialPositionRadius: 100,
        seriesInteraction: !0,
        marker: {
          fillColor: null,
          fillOpacity: 1,
          lineWidth: null,
          lineColor: null,
          symbol: "circle"
        }
      },
      enableSimulation: !0,
      type: "packedbubble",
      integration: "packedbubble",
      maxIterations: 1000,
      splitSeries: !1,
      maxSpeed: 5,
      gravitationalConstant: 0.01,
      friction: -0.981
    },
    stickyTracking: !1
  }), i_(iQ.prototype, {
    pointClass: e7,
    axisTypes: [],
    directTouch: !0,
    forces: ["barycenter", "repulsive"],
    hasDraggableNodes: !0,
    invertible: !1,
    isCartesian: !1,
    noSharedTooltip: !0,
    pointArrayMap: ["value"],
    pointValKey: "value",
    requireSorting: !1,
    trackerGroups: ["group", "dataLabelsGroup", "parentNodesGroup"],
    initDataLabels: iW,
    alignDataLabel: iH.alignDataLabel,
    indexateNodes: iO,
    onMouseDown: eZ.onMouseDown,
    onMouseMove: eZ.onMouseMove,
    redrawHalo: eZ.redrawHalo,
    searchPoint: iO
  }), P().registerSeriesType("packedbubble", iQ);
  let {
      noop: iJ
    } = y(),
    {
      area: i0,
      line: i1,
      scatter: i2
    } = P().seriesTypes,
    {
      extend: i3,
      merge: i5
    } = y();
  class i8 extends i2 {
    getGraphPath() {
      let t = i1.prototype.getGraphPath.call(this),
        e = t.length + 1;
      for (; e--;) (e === t.length || "M" === t[e][0]) && e > 0 && t.splice(e, 0, ["Z"]);
      return this.areaPath = t, t;
    }
    drawGraph() {
      this.options.fillColor = this.color, i0.prototype.drawGraph.call(this);
    }
  }
  i8.defaultOptions = i5(i2.defaultOptions, {
    marker: {
      enabled: !1,
      states: {
        hover: {
          enabled: !1
        }
      }
    },
    stickyTracking: !1,
    tooltip: {
      followPointer: !0,
      pointFormat: ""
    },
    trackByArea: !0,
    legendSymbol: "rectangle"
  }), i3(i8.prototype, {
    type: "polygon",
    drawTracker: i1.prototype.drawTracker,
    setStackedPoints: iJ
  }), P().registerSeriesType("polygon", i8);
  let {
      defaultOptions: i6
    } = y(),
    {
      noop: i9
    } = y(),
    {
      addEvent: i4,
      extend: i7,
      isObject: st,
      merge: se,
      relativeLength: si
    } = y(),
    ss = {
      radius: 0,
      scope: "stack",
      where: void 0
    },
    sa = i9,
    so = i9;
  function sr(t, e, i, s, a = {}) {
    let o = sa(t, e, i, s, a),
      {
        brStart: r = !0,
        brEnd: n = !0,
        innerR: l = 0,
        r: h = i,
        start: p = 0,
        end: d = 0
      } = a;
    if (a.open || !a.borderRadius) return o;
    let c = d - p,
      u = Math.sin(c / 2),
      g = Math.max(Math.min(si(a.borderRadius || 0, h - l), (h - l) / 2, h * u / (1 + u)), 0),
      f = Math.min(g, c / Math.PI * 2 * l),
      m = o.length - 1;
    for (; m--;) (r || 0 !== m && 3 !== m) && (n || 1 !== m && 2 !== m) && !function (t, e, i) {
      let s,
        a,
        o,
        r = t[e],
        n = t[e + 1];
      if ("Z" === n[0] && (n = t[0]), ("M" === r[0] || "L" === r[0]) && "A" === n[0] ? (s = r, a = n, o = !0) : "A" === r[0] && ("M" === n[0] || "L" === n[0]) && (s = n, a = r), s && a && a.params) {
        let r = a[1],
          n = a[5],
          l = a.params,
          {
            start: h,
            end: p,
            cx: d,
            cy: c
          } = l,
          u = n ? r - i : r + i,
          g = u ? Math.asin(i / u) : 0,
          f = n ? g : -g,
          m = Math.cos(g) * u;
        o ? (l.start = h + f, s[1] = d + m * Math.cos(h), s[2] = c + m * Math.sin(h), t.splice(e + 1, 0, ["A", i, i, 0, 0, 1, d + r * Math.cos(l.start), c + r * Math.sin(l.start)])) : (l.end = p - f, a[6] = d + r * Math.cos(l.end), a[7] = c + r * Math.sin(l.end), t.splice(e + 1, 0, ["A", i, i, 0, 0, 1, d + m * Math.cos(p), c + m * Math.sin(p)])), a[4] = Math.abs(l.end - l.start) < Math.PI ? 0 : 1;
      }
    }(o, m, m > 1 ? f : g);
    return o;
  }
  function sn() {
    if ((this || _global).options.borderRadius && !((this || _global).chart.is3d && (this || _global).chart.is3d())) {
      let {
          options: t,
          yAxis: e
        } = this || _global,
        i = "percent" === t.stacking,
        s = i6.plotOptions?.[(this || _global).type]?.borderRadius,
        a = sl(t.borderRadius, st(s) ? s : {}),
        o = e.options.reversed;
      for (let s of (this || _global).points) {
        let {
          shapeArgs: r
        } = s;
        if ("roundedRect" === s.shapeType && r) {
          let {
              width: n = 0,
              height: l = 0,
              y: h = 0
            } = r,
            p = h,
            d = l;
          if ("stack" === a.scope && s.stackTotal) {
            let a = e.translate(i ? 100 : s.stackTotal, !1, !0, !1, !0),
              o = e.translate(t.threshold || 0, !1, !0, !1, !0),
              r = this.crispCol(0, Math.min(a, o), 0, Math.abs(a - o));
            p = r.y, d = r.height;
          }
          let c = (s.negative ? -1 : 1) * (o ? -1 : 1) == -1,
            u = a.where;
          !u && this.is("waterfall") && Math.abs((s.yBottom || 0) - ((this || _global).translatedThreshold || 0)) > (this || _global).borderWidth && (u = "all"), u || (u = "end");
          let g = Math.min(si(a.radius, n), n / 2, "all" === u ? l / 2 : 1 / 0) || 0;
          "end" === u && (c && (p -= g), d += g), i7(r, {
            brBoxHeight: d,
            brBoxY: p,
            r: g
          });
        }
      }
    }
  }
  function sl(t, e) {
    return st(t) || (t = {
      radius: t || 0
    }), se(ss, e, t);
  }
  function sh() {
    let t = sl((this || _global).options.borderRadius);
    for (let e of (this || _global).points) {
      let i = e.shapeArgs;
      i && (i.borderRadius = si(t.radius, (i.r || 0) - (i.innerR || 0)));
    }
  }
  function sp(t, e, i, s, a = {}) {
    let o = so(t, e, i, s, a),
      {
        r = 0,
        brBoxHeight: n = s,
        brBoxY: l = e
      } = a,
      h = e - l,
      p = l + n - (e + s),
      d = h - r > -0.1 ? 0 : r,
      c = p - r > -0.1 ? 0 : r,
      u = Math.max(d && h, 0),
      g = Math.max(c && p, 0),
      f = [t + d, e],
      m = [t + i - d, e],
      b = [t + i, e + d],
      y = [t + i, e + s - c],
      x = [t + i - c, e + s],
      P = [t + c, e + s],
      M = [t, e + s - c],
      v = [t, e + d],
      L = (t, e) => Math.sqrt(Math.pow(t, 2) - Math.pow(e, 2));
    if (u) {
      let t = L(d, d - u);
      f[0] -= t, m[0] += t, b[1] = v[1] = e + d - u;
    }
    if (s < d - u) {
      let a = L(d, d - u - s);
      b[0] = y[0] = t + i - d + a, x[0] = Math.min(b[0], x[0]), P[0] = Math.max(y[0], P[0]), M[0] = v[0] = t + d - a, b[1] = v[1] = e + s;
    }
    if (g) {
      let t = L(c, c - g);
      x[0] += t, P[0] -= t, y[1] = M[1] = e + s - c + g;
    }
    if (s < c - g) {
      let a = L(c, c - g - s);
      b[0] = y[0] = t + i - c + a, m[0] = Math.min(b[0], m[0]), f[0] = Math.max(y[0], f[0]), M[0] = v[0] = t + c - a, y[1] = M[1] = e;
    }
    return o.length = 0, o.push(["M", ...f], ["L", ...m], ["A", d, d, 0, 0, 1, ...b], ["L", ...y], ["A", c, c, 0, 0, 1, ...x], ["L", ...P], ["A", c, c, 0, 0, 1, ...M], ["L", ...v], ["A", d, d, 0, 0, 1, ...f], ["Z"]), o;
  }
  let sd = {
      circular: {
        gridLineWidth: 1,
        labels: {
          align: void 0,
          x: 0,
          y: void 0
        },
        maxPadding: 0,
        minPadding: 0,
        showLastLabel: !1,
        tickLength: 0
      },
      radial: {
        gridLineInterpolation: "circle",
        gridLineWidth: 1,
        labels: {
          align: "right",
          padding: 5,
          x: -3,
          y: -2
        },
        showLastLabel: !1,
        title: {
          x: 4,
          text: null,
          rotation: 90
        }
      },
      radialGauge: {
        endOnTick: !1,
        gridLineWidth: 0,
        labels: {
          align: "center",
          distance: -25,
          x: 0,
          y: void 0
        },
        lineWidth: 1,
        minorGridLineWidth: 0,
        minorTickInterval: "auto",
        minorTickLength: 10,
        minorTickPosition: "inside",
        minorTickWidth: 1,
        startOnTick: !1,
        tickLength: 10,
        tickPixelInterval: 100,
        tickPosition: "inside",
        tickWidth: 2,
        title: {
          rotation: 0,
          text: ""
        },
        zIndex: 2
      }
    },
    {
      defaultOptions: sc
    } = y(),
    {
      composed: su,
      noop: sg
    } = y(),
    {
      addEvent: sf,
      correctFloat: sm,
      defined: sb,
      extend: sy,
      fireEvent: sx,
      isObject: sP,
      merge: sM,
      pick: sv,
      pushUnique: sL,
      relativeLength: sk,
      splat: sw,
      wrap: sA
    } = y();
  !function (t) {
    function e() {
      (this || _global).autoConnect = (this || _global).isCircular && void 0 === sv((this || _global).userMax, (this || _global).options.max) && sm((this || _global).endAngleRad - (this || _global).startAngleRad) === sm(2 * Math.PI), !(this || _global).isCircular && (this || _global).chart.inverted && (this || _global).max++, (this || _global).autoConnect && ((this || _global).max += (this || _global).categories && 1 || (this || _global).pointRange || (this || _global).closestPointRange || 0);
    }
    function i() {
      return () => {
        if ((this || _global).isRadial && (this || _global).tickPositions && (this || _global).options.labels && !0 !== (this || _global).options.labels.allowOverlap) return (this || _global).tickPositions.map(t => (this || _global).ticks[t]?.label).filter(t => !!t);
      };
    }
    function s() {
      return sg;
    }
    function a(t, e, i) {
      let s = (this || _global).pane.center,
        a = t.value,
        o,
        r,
        n;
      return (this || _global).isCircular ? (sb(a) ? t.point && (t.point.shapeArgs || {}).start && (a = (this || _global).chart.inverted ? this.translate(t.point.rectPlotY, !0) : t.point.x) : (r = t.chartX || 0, n = t.chartY || 0, a = this.translate(Math.atan2(n - i, r - e) - (this || _global).startAngleRad, !0)), r = (o = this.getPosition(a)).x, n = o.y) : (sb(a) || (r = t.chartX, n = t.chartY), sb(r) && sb(n) && (i = s[1] + (this || _global).chart.plotTop, a = this.translate(Math.min(Math.sqrt(Math.pow(r - e, 2) + Math.pow(n - i, 2)), s[2] / 2) - s[3] / 2, !0))), [a, r || 0, n || 0];
    }
    function o(t, e, i) {
      let s = (this || _global).pane.center,
        a = (this || _global).chart,
        o = (this || _global).left || 0,
        r = (this || _global).top || 0,
        n,
        l = sv(e, s[2] / 2 - (this || _global).offset),
        h;
      return void 0 === i && (i = (this || _global).horiz ? 0 : (this || _global).center && -(this || _global).center[3] / 2), i && (l += i), (this || _global).isCircular || void 0 !== e ? ((h = (this || _global).chart.renderer.symbols.arc(o + s[0], r + s[1], l, l, {
        start: (this || _global).startAngleRad,
        end: (this || _global).endAngleRad,
        open: !0,
        innerR: 0
      })).xBounds = [o + s[0]], h.yBounds = [r + s[1] - l]) : (n = this.postTranslate((this || _global).angleRad, l), h = [["M", (this || _global).center[0] + a.plotLeft, (this || _global).center[1] + a.plotTop], ["L", n.x, n.y]]), h;
    }
    function r() {
      (this || _global).constructor.prototype.getOffset.call(this || _global), (this || _global).chart.axisOffset[(this || _global).side] = 0;
    }
    function n(t, e, i) {
      let s = (this || _global).chart,
        a = t => {
          if ("string" == typeof t) {
            let e = parseInt(t, 10);
            return c.test(t) && (e = e * l / 100), e;
          }
          return t;
        },
        o = (this || _global).center,
        r = (this || _global).startAngleRad,
        n = i.borderRadius,
        l = o[2] / 2,
        h = Math.min((this || _global).offset, 0),
        p = (this || _global).left || 0,
        d = (this || _global).top || 0,
        c = /%$/,
        u = (this || _global).isCircular,
        g = (this || _global).options.plotBands || [],
        f = g.indexOf(i),
        m,
        b,
        y,
        x,
        P,
        M,
        v = sv(a(i.outerRadius), l),
        L = a(i.innerRadius),
        k = sv(a(i.thickness), 10),
        w = !0,
        A = !0;
      if (n && f > -1 && (g[f - 1] && g[f - 1].to === t && (w = !1), g[f + 1] && g[f + 1].from === e && (A = !1)), "polygon" === (this || _global).options.gridLineInterpolation) M = this.getPlotLinePath({
        value: t
      }).concat(this.getPlotLinePath({
        value: e,
        reverse: !0
      }));else {
        t = Math.max(t, (this || _global).min), e = Math.min(e, (this || _global).max);
        let a = this.translate(t),
          l = this.translate(e);
        u || (v = a || 0, L = l || 0), "circle" !== i.shape && u ? (m = r + (a || 0), b = r + (l || 0)) : (m = -Math.PI / 2, b = 1.5 * Math.PI, P = !0), v -= h, k -= h, M = s.renderer.symbols.arc(p + o[0], d + o[1], v, v, {
          start: Math.min(m, b),
          end: Math.max(m, b),
          innerR: sv(L, v - k),
          open: P,
          borderRadius: n,
          brStart: w,
          brEnd: A
        }), u && (y = (b + m) / 2, x = p + o[0] + o[2] / 2 * Math.cos(y), M.xBounds = y > -Math.PI / 2 && y < Math.PI / 2 ? [x, s.plotWidth] : [0, x], M.yBounds = [d + o[1] + o[2] / 2 * Math.sin(y)], M.yBounds[0] += y > -Math.PI && y < 0 || y > Math.PI ? -10 : 10);
      }
      return M;
    }
    function l(t) {
      let e = (this || _global).pane.center,
        i = (this || _global).chart,
        s = i.inverted,
        a = t.reverse,
        o = (this || _global).pane.options.background,
        r = o ? sw(o)[0] : {},
        n = r.innerRadius || "0%",
        l = r.outerRadius || "100%",
        h = e[0] + i.plotLeft,
        p = e[1] + i.plotTop,
        d = (this || _global).height,
        c = t.isCrosshair,
        u = e[3] / 2,
        g = t.value,
        f,
        m,
        b,
        y,
        x,
        P,
        M,
        v,
        L,
        k = this.getPosition(g),
        w = k.x,
        A = k.y;
      if (c && (g = (v = this.getCrosshairPosition(t, h, p))[0], w = v[1], A = v[2]), (this || _global).isCircular) m = Math.sqrt(Math.pow(w - h, 2) + Math.pow(A - p, 2)), b = "string" == typeof n ? sk(n, 1) : n / m, y = "string" == typeof l ? sk(l, 1) : l / m, e && u && (b < (f = u / m) && (b = f), y < f && (y = f)), L = [["M", h + b * (w - h), p - b * (p - A)], ["L", w - (1 - y) * (w - h), A + (1 - y) * (p - A)]];else if ((g = this.translate(g)) && (g < 0 || g > d) && (g = 0), "circle" === (this || _global).options.gridLineInterpolation) L = this.getLinePath(0, g, u);else if (L = [], i[s ? "yAxis" : "xAxis"].forEach(t => {
        t.pane === (this || _global).pane && (x = t);
      }), x) {
        M = x.tickPositions, x.autoConnect && (M = M.concat([M[0]])), a && (M = M.slice().reverse()), g && (g += u);
        for (let t = 0; t < M.length; t++) P = x.getPosition(M[t], g), L.push(t ? ["L", P.x, P.y] : ["M", P.x, P.y]);
      }
      return L;
    }
    function h(t, e) {
      let i = this.translate(t);
      return this.postTranslate((this || _global).isCircular ? i : (this || _global).angleRad, sv((this || _global).isCircular ? e : i < 0 ? 0 : i, (this || _global).center[2] / 2) - (this || _global).offset);
    }
    function p() {
      let t = (this || _global).center,
        e = (this || _global).chart,
        i = (this || _global).options.title;
      return {
        x: e.plotLeft + t[0] + (i.x || 0),
        y: e.plotTop + t[1] - {
          high: 0.5,
          middle: 0.25,
          low: 0
        }[i.align] * t[2] + (i.y || 0)
      };
    }
    function d(t) {
      t.beforeSetTickPositions = e, t.createLabelCollector = i, t.getCrosshairPosition = a, t.getLinePath = o, t.getOffset = r, t.getPlotBandPath = n, t.getPlotLinePath = l, t.getPosition = h, t.getTitlePosition = p, t.postTranslate = M, t.setAxisSize = L, t.setAxisTranslation = k, t.setOptions = w;
    }
    function c() {
      let t = (this || _global).chart,
        e = (this || _global).options,
        i = t.angular && (this || _global).isXAxis,
        s = (this || _global).pane,
        a = s?.options;
      if (!i && s && (t.angular || t.polar)) {
        let t = 2 * Math.PI,
          i = (sv(a.startAngle, 0) - 90) * Math.PI / 180,
          s = (sv(a.endAngle, sv(a.startAngle, 0) + 360) - 90) * Math.PI / 180;
        (this || _global).angleRad = (e.angle || 0) * Math.PI / 180, (this || _global).startAngleRad = i, (this || _global).endAngleRad = s, (this || _global).offset = e.offset || 0;
        let o = (i % t + t) % t,
          r = (s % t + t) % t;
        o > Math.PI && (o -= t), r > Math.PI && (r -= t), (this || _global).normalizedStartAngleRad = o, (this || _global).normalizedEndAngleRad = r;
      }
    }
    function u(t) {
      (this || _global).isRadial && (t.align = void 0, t.preventDefault());
    }
    function g() {
      if ((this || _global).chart?.labelCollectors) {
        let t = (this || _global).labelCollector ? (this || _global).chart.labelCollectors.indexOf((this || _global).labelCollector) : -1;
        t >= 0 && (this || _global).chart.labelCollectors.splice(t, 1);
      }
    }
    function f(t) {
      let e,
        i = (this || _global).chart,
        a = i.angular,
        o = i.polar,
        r = (this || _global).isXAxis,
        n = (this || _global).coll,
        l = t.userOptions.pane || 0,
        h = (this || _global).pane = i.pane && i.pane[l];
      if ("colorAxis" === n) {
        (this || _global).isRadial = !1;
        return;
      }
      if (a) {
        if (a && r) (this || _global).isHidden = !0, (this || _global).createLabelCollector = s, (this || _global).getOffset = sg, (this || _global).redraw = v, (this || _global).render = v, (this || _global).setScale = sg, (this || _global).setCategories = sg, (this || _global).setTitle = sg;else d(this || _global);
        e = !r;
      } else o && (d(this || _global), e = (this || _global).horiz);
      a || o ? ((this || _global).isRadial = !0, (this || _global).labelCollector || ((this || _global).labelCollector = this.createLabelCollector()), (this || _global).labelCollector && i.labelCollectors.push((this || _global).labelCollector)) : (this || _global).isRadial = !1, h && e && (h.axis = this || _global), (this || _global).isCircular = e;
    }
    function m() {
      (this || _global).isRadial && this.beforeSetTickPositions();
    }
    function b(t) {
      let e = (this || _global).label;
      if (!e) return;
      let i = (this || _global).axis,
        s = e.getBBox(),
        a = i.options.labels,
        o = (i.translate((this || _global).pos) + i.startAngleRad + Math.PI / 2) / Math.PI * 180 % 360,
        r = Math.round(o),
        n = sb(a.y) ? 0 : -(0.3 * s.height),
        l = a.y,
        h,
        p = 20,
        d = a.align,
        c = "end",
        u = r < 0 ? r + 360 : r,
        g = u,
        f = 0,
        m = 0;
      i.isRadial && (h = i.getPosition((this || _global).pos, i.center[2] / 2 + sk(sv(a.distance, -25), i.center[2] / 2, -i.center[2] / 2)), "auto" === a.rotation ? e.attr({
        rotation: o
      }) : sb(l) || (l = i.chart.renderer.fontMetrics(e).b - s.height / 2), sb(d) || (i.isCircular ? (s.width > i.len * i.tickInterval / (i.max - i.min) && (p = 0), d = o > p && o < 180 - p ? "left" : o > 180 + p && o < 360 - p ? "right" : "center") : d = "center", e.attr({
        align: d
      })), "auto" === d && 2 === i.tickPositions.length && i.isCircular && (u > 90 && u < 180 ? u = 180 - u : u > 270 && u <= 360 && (u = 540 - u), g > 180 && g <= 360 && (g = 360 - g), (i.pane.options.startAngle === r || i.pane.options.startAngle === r + 360 || i.pane.options.startAngle === r - 360) && (c = "start"), d = r >= -90 && r <= 90 || r >= -360 && r <= -270 || r >= 270 && r <= 360 ? "start" === c ? "right" : "left" : "start" === c ? "left" : "right", g > 70 && g < 110 && (d = "center"), u < 15 || u >= 180 && u < 195 ? f = 0.3 * s.height : u >= 15 && u <= 35 ? f = "start" === c ? 0 : 0.75 * s.height : u >= 195 && u <= 215 ? f = "start" === c ? 0.75 * s.height : 0 : u > 35 && u <= 90 ? f = "start" === c ? -(0.25 * s.height) : s.height : u > 215 && u <= 270 && (f = "start" === c ? s.height : -(0.25 * s.height)), g < 15 ? m = "start" === c ? -(0.15 * s.height) : 0.15 * s.height : g > 165 && g <= 180 && (m = "start" === c ? 0.15 * s.height : -(0.15 * s.height)), e.attr({
        align: d
      }), e.translate(m, f + n)), t.pos.x = h.x + (a.x || 0), t.pos.y = h.y + (l || 0));
    }
    function x(t) {
      (this || _global).axis.getPosition && sy(t.pos, (this || _global).axis.getPosition((this || _global).pos));
    }
    function P({
      options: e
    }) {
      e.xAxis && sM(!0, t.radialDefaultOptions.circular, e.xAxis), e.yAxis && sM(!0, t.radialDefaultOptions.radialGauge, e.yAxis);
    }
    function M(t, e) {
      let i = (this || _global).chart,
        s = (this || _global).center;
      return t = (this || _global).startAngleRad + t, {
        x: i.plotLeft + s[0] + Math.cos(t) * e,
        y: i.plotTop + s[1] + Math.sin(t) * e
      };
    }
    function v() {
      (this || _global).isDirty = !1;
    }
    function L() {
      let t, e;
      (this || _global).constructor.prototype.setAxisSize.call(this || _global), (this || _global).isRadial && ((this || _global).pane.updateCenter(this || _global), t = (this || _global).center = (this || _global).pane.center.slice(), (this || _global).isCircular ? (this || _global).sector = (this || _global).endAngleRad - (this || _global).startAngleRad : (e = this.postTranslate((this || _global).angleRad, t[3] / 2), t[0] = e.x - (this || _global).chart.plotLeft, t[1] = e.y - (this || _global).chart.plotTop), (this || _global).len = (this || _global).width = (this || _global).height = (t[2] - t[3]) * sv((this || _global).sector, 1) / 2);
    }
    function k() {
      (this || _global).constructor.prototype.setAxisTranslation.call(this || _global), (this || _global).center && ((this || _global).isCircular ? (this || _global).transA = ((this || _global).endAngleRad - (this || _global).startAngleRad) / ((this || _global).max - (this || _global).min || 1) : (this || _global).transA = ((this || _global).center[2] - (this || _global).center[3]) / 2 / ((this || _global).max - (this || _global).min || 1), (this || _global).isXAxis ? (this || _global).minPixelPadding = (this || _global).transA * (this || _global).minPointOffset : (this || _global).minPixelPadding = 0);
    }
    function w(e) {
      let {
          coll: i
        } = this || _global,
        {
          angular: s,
          inverted: a,
          polar: o
        } = (this || _global).chart,
        r = {};
      s ? (this || _global).isXAxis || (r = sM(sc.yAxis, t.radialDefaultOptions.radialGauge)) : o && (r = (this || _global).horiz ? sM(sc.xAxis, t.radialDefaultOptions.circular) : sM("xAxis" === i ? sc.xAxis : sc.yAxis, t.radialDefaultOptions.radial)), a && "yAxis" === i && (r.stackLabels = sP(sc.yAxis, !0) ? sc.yAxis.stackLabels : {}, r.reversedStacks = !0);
      let n = (this || _global).options = sM(r, e);
      n.plotBands || (n.plotBands = []), sx(this || _global, "afterSetOptions");
    }
    function A(t, e, i, s, a, o, r) {
      let n,
        l,
        h = (this || _global).axis;
      return h.isRadial ? ["M", e, i, "L", (n = h.getPosition((this || _global).pos, h.center[2] / 2 + s)).x, n.y] : t.call(this || _global, e, i, s, a, o, r);
    }
    t.radialDefaultOptions = sM(sd), t.compose = function (t, e) {
      return sL(su, "Axis.Radial") && (sf(t, "afterInit", c), sf(t, "autoLabelAlign", u), sf(t, "destroy", g), sf(t, "init", f), sf(t, "initialAxisTranslation", m), sf(e, "afterGetLabelPosition", b), sf(e, "afterGetPosition", x), sf(y(), "setOptions", P), sA(e.prototype, "getMarkPath", A)), t;
    };
  }(d || (d = {}));
  let sS = d,
    {
      animObject: sT
    } = y(),
    {
      optionsToObject: sC
    } = {
      compose: function (t, e, i) {
        let s = t.types.pie;
        if (!e.symbolCustomAttribs.includes("borderRadius")) {
          let a = i.prototype.symbols;
          i4(t, "afterColumnTranslate", sn, {
            order: 9
          }), i4(s, "afterTranslate", sh), e.symbolCustomAttribs.push("borderRadius", "brBoxHeight", "brBoxY", "brEnd", "brStart"), sa = a.arc, so = a.roundedRect, a.arc = sr, a.roundedRect = sp;
        }
      },
      optionsToObject: sl
    },
    {
      defaultOptions: sN
    } = y(),
    {
      composed: sX
    } = y(),
    {
      addEvent: sY,
      defined: sR,
      find: sI,
      isNumber: sE,
      isObject: sD,
      merge: sz,
      pick: sO,
      pushUnique: sH,
      relativeLength: sB,
      splat: sW,
      uniqueKey: sF,
      wrap: sG
    } = y();
  function sq() {
    ((this || _global).pane || []).forEach(t => {
      t.render();
    });
  }
  function sV(t) {
    let e = t.args[0].xAxis,
      i = t.args[0].yAxis,
      s = t.args[0].chart;
    e && i && ("polygon" === i.gridLineInterpolation ? (e.startOnTick = !0, e.endOnTick = !0) : "polygon" === e.gridLineInterpolation && s.inverted && (i.startOnTick = !0, i.endOnTick = !0));
  }
  function s_() {
    (this || _global).pane || ((this || _global).pane = []), (this || _global).options.pane = sW((this || _global).options.pane || {}), sW((this || _global).userOptions.pane || {}).forEach(t => {
      new V(t, this || _global);
    }, this || _global);
  }
  function sU(t) {
    let e = t.args.marker,
      i = (this || _global).chart.xAxis[0],
      s = (this || _global).chart.yAxis[0],
      a = (this || _global).chart.inverted,
      o = a ? s : i,
      r = a ? i : s;
    if ((this || _global).chart.polar) {
      t.preventDefault();
      let i = (e.attr ? e.attr("start") : e.start) - o.startAngleRad,
        s = e.attr ? e.attr("r") : e.r,
        a = (e.attr ? e.attr("end") : e.end) - o.startAngleRad,
        n = e.attr ? e.attr("innerR") : e.innerR;
      t.result.x = i + o.pos, t.result.width = a - i, t.result.y = r.len + r.pos - s, t.result.height = s - n;
    }
  }
  function sK(t) {
    let e = (this || _global).chart;
    if (e.polar && e.hoverPane && e.hoverPane.axis) {
      t.preventDefault();
      let i = e.hoverPane.center,
        s = e.mouseDownX || 0,
        a = e.mouseDownY || 0,
        o = t.args.chartY,
        r = t.args.chartX,
        n = 2 * Math.PI,
        l = e.hoverPane.axis.startAngleRad,
        h = e.hoverPane.axis.endAngleRad,
        p = e.inverted ? e.xAxis[0] : e.yAxis[0],
        d = {},
        c = "arc";
      if (d.x = i[0] + e.plotLeft, d.y = i[1] + e.plotTop, (this || _global).zoomHor) {
        let t = l > 0 ? h - l : Math.abs(l) + Math.abs(h),
          u = Math.atan2(a - e.plotTop - i[1], s - e.plotLeft - i[0]) - l,
          g = Math.atan2(o - e.plotTop - i[1], r - e.plotLeft - i[0]) - l;
        d.r = i[2] / 2, d.innerR = i[3] / 2, u <= 0 && (u += n), g <= 0 && (g += n), g < u && (g = [u, u = g][0]), t < n && l + g > h + (n - t) / 2 && (g = u, u = l <= 0 ? l : 0);
        let f = d.start = Math.max(u + l, l),
          m = d.end = Math.min(g + l, h);
        if ("polygon" === p.options.gridLineInterpolation) {
          let t = e.hoverPane.axis,
            s = f - t.startAngleRad + t.pos,
            a = p.getPlotLinePath({
              value: p.max
            }),
            o = t.toValue(s),
            r = t.toValue(s + (m - f));
          if (o < t.getExtremes().min) {
            let {
              min: e,
              max: i
            } = t.getExtremes();
            o = i - (e - o);
          }
          if (r < t.getExtremes().min) {
            let {
              min: e,
              max: i
            } = t.getExtremes();
            r = i - (e - r);
          }
          r < o && (r = [o, o = r][0]), (a = sJ(a, o, r, t)).push(["L", i[0] + e.plotLeft, e.plotTop + i[1]]), d.d = a, c = "path";
        }
      }
      if ((this || _global).zoomVert) {
        let t = e.inverted ? e.xAxis[0] : e.yAxis[0],
          n = Math.sqrt(Math.pow(s - e.plotLeft - i[0], 2) + Math.pow(a - e.plotTop - i[1], 2)),
          p = Math.sqrt(Math.pow(r - e.plotLeft - i[0], 2) + Math.pow(o - e.plotTop - i[1], 2));
        if (p < n && (n = [p, p = n][0]), p > i[2] / 2 && (p = i[2] / 2), n < i[3] / 2 && (n = i[3] / 2), (this || _global).zoomHor || (d.start = l, d.end = h), d.r = p, d.innerR = n, "polygon" === t.options.gridLineInterpolation) {
          let e = t.toValue(t.len + t.pos - n),
            i = t.toValue(t.len + t.pos - p);
          d.d = t.getPlotLinePath({
            value: i
          }).concat(t.getPlotLinePath({
            value: e,
            reverse: !0
          })), c = "path";
        }
      }
      if ((this || _global).zoomHor && (this || _global).zoomVert && "polygon" === p.options.gridLineInterpolation) {
        let t = e.hoverPane.axis,
          i = d.start || 0,
          s = d.end || 0,
          a = i - t.startAngleRad + t.pos,
          o = t.toValue(a),
          r = t.toValue(a + (s - i));
        if (d.d instanceof Array) {
          let t = d.d.slice(0, d.d.length / 2),
            i = d.d.slice(d.d.length / 2, d.d.length);
          i = [...i].reverse();
          let s = e.hoverPane.axis;
          t = sJ(t, o, r, s), (i = sJ(i, o, r, s)) && (i[0][0] = "L"), i = [...i].reverse(), d.d = t.concat(i), c = "path";
        }
      }
      t.attrs = d, t.shapeType = c;
    }
  }
  function sj() {
    let t = (this || _global).chart;
    t.polar && ((this || _global).polar = new s7(this || _global), t.inverted && ((this || _global).isRadialSeries = !0, this.is("column") && ((this || _global).isRadialBar = !0)));
  }
  function sZ() {
    let {
      chart: t,
      options: e,
      yAxis: i
    } = this || _global;
    if (e.borderRadius && t.polar && t.inverted) {
      let t = sN.plotOptions?.[(this || _global).type]?.borderRadius,
        {
          scope: s,
          where: a = "end"
        } = sC(e.borderRadius, sD(t) ? t : {});
      for (let t of (this || _global).points) {
        let {
          shapeArgs: o
        } = t;
        if ("arc" === t.shapeType && o) {
          let r = "all" === a,
            n = !0;
          e.stacking && "stack" === s && (r = t.stackY === t.y && "all" === a, n = t.stackY === t.stackTotal), i.reversed && ([r, n] = [n, r]), o.brStart = r, o.brEnd = n;
        }
      }
    }
  }
  function s$() {
    if ((this || _global).chart.polar && (this || _global).xAxis) {
      let {
          xAxis: t,
          yAxis: e
        } = this || _global,
        i = (this || _global).chart;
      (this || _global).kdByAngle = i.tooltip && i.tooltip.shared, (this || _global).kdByAngle || i.inverted ? (this || _global).searchPoint = sQ : (this || _global).options.findNearestPointBy = "xy";
      let s = (this || _global).points,
        a = s.length;
      for (; a--;) this.is("column") || this.is("columnrange") || (this || _global).polar.toXY(s[a]), i.hasParallelCoordinates || (this || _global).yAxis.reversed || (sO(s[a].y, Number.MIN_VALUE) < e.min || s[a].x < t.min || s[a].x > t.max ? (s[a].isNull = !0, s[a].plotY = NaN) : s[a].isNull = s[a].isValid && !s[a].isValid());
      (this || _global).hasClipCircleSetter || ((this || _global).hasClipCircleSetter = !!(this || _global).eventsToUnbind.push(sY(this || _global, "afterRender", function () {
        let t;
        i.polar && !1 !== (this || _global).options.clip && (t = (this || _global).yAxis.pane.center, (this || _global).clipCircle ? (this || _global).clipCircle.animate({
          x: t[0],
          y: t[1],
          r: t[2] / 2,
          innerR: t[3] / 2
        }) : (this || _global).clipCircle = function (t, e, i, s, a) {
          let o = sF(),
            r = t.createElement("clipPath").attr({
              id: o
            }).add(t.defs),
            n = a ? t.arc(e, i, s, a, 0, 2 * Math.PI).add(r) : t.circle(e, i, s).add(r);
          return n.id = o, n.clipPath = r, n;
        }(i.renderer, t[0], t[1], t[2] / 2, t[3] / 2), (this || _global).group.clip((this || _global).clipCircle), (this || _global).setClip = y().noop);
      })));
    }
  }
  function sQ(t) {
    let e = (this || _global).chart,
      i = (this || _global).xAxis,
      s = (this || _global).yAxis,
      a = i.pane && i.pane.center,
      o = t.chartX - (a && a[0] || 0) - e.plotLeft,
      r = t.chartY - (a && a[1] || 0) - e.plotTop,
      n = e.inverted ? {
        clientX: t.chartX - s.pos,
        plotY: t.chartY - i.pos
      } : {
        clientX: 180 + -180 / Math.PI * Math.atan2(o, r)
      };
    return this.searchKDTree(n);
  }
  function sJ(t, e, i, s) {
    let a = s.tickInterval,
      o = s.tickPositions,
      r = sI(o, t => t >= i),
      n = sI([...o].reverse(), t => t <= e);
    return sR(r) || (r = o[o.length - 1]), sR(n) || (n = o[0], r += a, t[0][0] = "L", t.unshift(t[t.length - 3])), (t = t.slice(o.indexOf(n), o.indexOf(r) + 1))[0][0] = "M", t;
  }
  function s0(t, e) {
    return sI((this || _global).pane || [], t => t.options.id === e) || t.call(this || _global, e);
  }
  function s1(t, e, i, s, a, o) {
    let r,
      n,
      l,
      h = (this || _global).chart,
      p = sO(s.inside, !!(this || _global).options.stacking);
    if (h.polar) {
      if (r = e.rectPlotX / Math.PI * 180, h.inverted) (this || _global).forceDL = h.isInsidePlot(e.plotX, e.plotY), p && e.shapeArgs ? (n = e.shapeArgs, a = sz(a, {
        x: (l = (this || _global).yAxis.postTranslate(((n.start || 0) + (n.end || 0)) / 2 - (this || _global).xAxis.startAngleRad, e.barX + e.pointWidth / 2)).x - h.plotLeft,
        y: l.y - h.plotTop
      })) : e.tooltipPos && (a = sz(a, {
        x: e.tooltipPos[0],
        y: e.tooltipPos[1]
      })), s.align = sO(s.align, "center"), s.verticalAlign = sO(s.verticalAlign, "middle");else {
        var d;
        null === (d = s).align && (d.align = r > 20 && r < 160 ? "left" : r > 200 && r < 340 ? "right" : "center"), null === d.verticalAlign && (d.verticalAlign = r < 45 || r > 315 ? "bottom" : r > 135 && r < 225 ? "top" : "middle"), s = d;
      }
      v().prototype.alignDataLabel.call(this || _global, e, i, s, a, o), (this || _global).isRadialBar && e.shapeArgs && e.shapeArgs.start === e.shapeArgs.end ? i.hide() : i.show();
    } else t.call(this || _global, e, i, s, a, o);
  }
  function s2() {
    let t = (this || _global).options,
      e = t.stacking,
      i = (this || _global).chart,
      s = (this || _global).xAxis,
      a = (this || _global).yAxis,
      o = a.reversed,
      r = a.center,
      n = s.startAngleRad,
      l = s.endAngleRad - n,
      h = t.threshold,
      p = 0,
      d,
      c,
      u,
      g,
      f,
      m = 0,
      b = 0,
      x,
      P,
      M,
      v,
      L,
      k,
      w,
      A;
    if (s.isRadial) for (u = (d = (this || _global).points).length, g = a.translate(a.min), f = a.translate(a.max), h = t.threshold || 0, i.inverted && sE(h) && sR(p = a.translate(h)) && (p < 0 ? p = 0 : p > l && (p = l), (this || _global).translatedThreshold = p + n); u--;) {
      if (k = (c = d[u]).barX, P = c.x, M = c.y, c.shapeType = "arc", i.inverted) {
        c.plotY = a.translate(M), e && a.stacking ? (L = a.stacking.stacks[(M < 0 ? "-" : "") + (this || _global).stackKey], (this || _global).visible && L && L[P] && !c.isNull && (v = L[P].points[this.getStackIndicator(void 0, P, (this || _global).index).key], m = a.translate(v[0]), b = a.translate(v[1]), sR(m) && (m = y().clamp(m, 0, l)))) : (m = p, b = c.plotY), m > b && (b = [m, m = b][0]), o ? b > g ? b = g : m < f ? m = f : (m > g || b < f) && (m = b = l) : m < g ? m = g : b > f ? b = f : (b < g || m > f) && (m = b = 0), a.min > a.max && (m = b = o ? l : 0), m += n, b += n, r && (c.barX = k += r[3] / 2), w = Math.max(k, 0), A = Math.max(k + c.pointWidth, 0);
        let i = t.borderRadius,
          s = sB(("object" == typeof i ? i.radius : i) || 0, A - w);
        c.shapeArgs = {
          x: r[0],
          y: r[1],
          r: A,
          innerR: w,
          start: m,
          end: b,
          borderRadius: s
        }, c.opacity = m === b ? 0 : void 0, c.plotY = (sR((this || _global).translatedThreshold) && (m < (this || _global).translatedThreshold ? m : b)) - n;
      } else m = k + n, c.shapeArgs = (this || _global).polar.arc(c.yBottom, c.plotY, m, m + c.pointWidth), c.shapeArgs.borderRadius = 0;
      (this || _global).polar.toXY(c), i.inverted ? (x = a.postTranslate(c.rectPlotY, k + c.pointWidth / 2), c.tooltipPos = [x.x - i.plotLeft, x.y - i.plotTop]) : c.tooltipPos = [c.plotX, c.plotY], r && (c.ttBelow = c.plotY > r[1]);
    }
  }
  function s3(t, e) {
    let i,
      s,
      a = this || _global;
    if ((this || _global).chart.polar) {
      e = e || (this || _global).points;
      for (let t = 0; t < e.length; t++) if (!e[t].isNull) {
        i = t;
        break;
      }
      !1 !== (this || _global).options.connectEnds && void 0 !== i && ((this || _global).connectEnds = !0, e.splice(e.length, 0, e[i]), s = !0), e.forEach(t => {
        void 0 === t.polarPlotY && a.polar.toXY(t);
      });
    }
    let o = t.apply(this || _global, [].slice.call(arguments, 1));
    return s && e.pop(), o;
  }
  function s5(t, e) {
    let i = (this || _global).chart,
      s = {
        xAxis: [],
        yAxis: []
      };
    return i.polar ? i.axes.forEach(t => {
      if ("colorAxis" === t.coll) return;
      let a = t.isXAxis,
        o = t.center,
        r = e.chartX - o[0] - i.plotLeft,
        n = e.chartY - o[1] - i.plotTop;
      s[a ? "xAxis" : "yAxis"].push({
        axis: t,
        value: t.translate(a ? Math.PI - Math.atan2(r, n) : Math.sqrt(Math.pow(r, 2) + Math.pow(n, 2)), !0)
      });
    }) : s = t.call(this || _global, e), s;
  }
  function s8(t, e) {
    (this || _global).chart.polar || t.call(this || _global, e);
  }
  function s6(t, e) {
    let i = this || _global,
      s = (this || _global).chart,
      a = (this || _global).group,
      o = (this || _global).markerGroup,
      r = (this || _global).xAxis && (this || _global).xAxis.center,
      n = s.plotLeft,
      l = s.plotTop,
      h = (this || _global).options.animation,
      p,
      d,
      c,
      u,
      g,
      f;
    s.polar ? i.isRadialBar ? e || (i.startAngleRad = sO(i.translatedThreshold, i.xAxis.startAngleRad), y().seriesTypes.pie.prototype.animate.call(i, e)) : (h = sT(h), i.is("column") ? e || (d = r[3] / 2, i.points.forEach(t => {
      c = t.graphic, g = (u = t.shapeArgs) && u.r, f = u && u.innerR, c && u && (c.attr({
        r: d,
        innerR: d
      }), c.animate({
        r: g,
        innerR: f
      }, i.options.animation));
    })) : e ? (p = {
      translateX: r[0] + n,
      translateY: r[1] + l,
      scaleX: 0.001,
      scaleY: 0.001
    }, a.attr(p), o && o.attr(p)) : (p = {
      translateX: n,
      translateY: l,
      scaleX: 1,
      scaleY: 1
    }, a.animate(p, h), o && o.animate(p, h))) : t.call(this || _global, e);
  }
  function s9(t, e, i, s) {
    let a, o;
    if ((this || _global).chart.polar) {
      if (s) {
        let t = (o = function t(e, i, s, a) {
            let o,
              r,
              n,
              l,
              h,
              p,
              d = +!!a,
              c = (o = i >= 0 && i <= e.length - 1 ? i : i < 0 ? e.length - 1 + i : 0) - 1 < 0 ? e.length - (1 + d) : o - 1,
              u = o + 1 > e.length - 1 ? d : o + 1,
              g = e[c],
              f = e[u],
              m = g.plotX,
              b = g.plotY,
              y = f.plotX,
              x = f.plotY,
              P = e[o].plotX,
              M = e[o].plotY;
            r = (1.5 * P + m) / 2.5, n = (1.5 * M + b) / 2.5, l = (1.5 * P + y) / 2.5, h = (1.5 * M + x) / 2.5;
            let v = Math.sqrt(Math.pow(r - P, 2) + Math.pow(n - M, 2)),
              L = Math.sqrt(Math.pow(l - P, 2) + Math.pow(h - M, 2)),
              k = Math.atan2(n - M, r - P);
            p = Math.PI / 2 + (k + Math.atan2(h - M, l - P)) / 2, Math.abs(k - p) > Math.PI / 2 && (p -= Math.PI), r = P + Math.cos(p) * v, n = M + Math.sin(p) * v;
            let w = {
              rightContX: l = P + Math.cos(Math.PI + p) * L,
              rightContY: h = M + Math.sin(Math.PI + p) * L,
              leftContX: r,
              leftContY: n,
              plotX: P,
              plotY: M
            };
            return s && (w.prevPointCont = t(e, c, !1, a)), w;
          }(e, s, !0, (this || _global).connectEnds)).prevPointCont && o.prevPointCont.rightContX,
          i = o.prevPointCont && o.prevPointCont.rightContY;
        a = ["C", sE(t) ? t : o.plotX, sE(i) ? i : o.plotY, sE(o.leftContX) ? o.leftContX : o.plotX, sE(o.leftContY) ? o.leftContY : o.plotY, o.plotX, o.plotY];
      } else a = ["M", i.plotX, i.plotY];
    } else a = t.call(this || _global, e, i, s);
    return a;
  }
  function s4(t, e, i = (this || _global).plotY) {
    if (!(this || _global).destroyed) {
      let {
          plotX: s,
          series: a
        } = this || _global,
        {
          chart: o
        } = a;
      return o.polar && sE(s) && sE(i) ? [s + (e ? o.plotLeft : 0), i + (e ? o.plotTop : 0)] : t.call(this || _global, e, i);
    }
  }
  class s7 {
    static compose(t, e, i, s, a, o, r, n, l, h) {
      if (V.compose(e, i), sS.compose(t, a), sH(sX, "Polar")) {
        let t = e.prototype,
          a = o.prototype,
          p = i.prototype,
          d = s.prototype;
        if (sY(e, "afterDrawChartBox", sq), sY(e, "createAxes", s_), sY(e, "init", sV), sG(t, "get", s0), sG(p, "getCoordinates", s5), sG(p, "pinch", s8), sY(i, "getSelectionMarkerAttrs", sK), sY(i, "getSelectionBox", sU), sY(s, "afterInit", sj), sY(s, "afterColumnTranslate", sZ, {
          order: 9
        }), sY(s, "afterTranslate", s$, {
          order: 2
        }), sY(s, "afterColumnTranslate", s2, {
          order: 4
        }), sG(d, "animate", s6), sG(a, "pos", s4), n) {
          let t = n.prototype;
          sG(t, "alignDataLabel", s1), sG(t, "animate", s6);
        }
        if (l && sG(l.prototype, "getGraphPath", s3), h) {
          let t = h.prototype;
          sG(t, "getPointSpline", s9), r && (r.prototype.getPointSpline = t.getPointSpline);
        }
      }
    }
    constructor(t) {
      this.series = t;
    }
    arc(t, e, i, s) {
      let a = this.series,
        o = a.xAxis.center,
        r = a.yAxis.len,
        n = o[3] / 2,
        l = r - e + n,
        h = r - sO(t, r) + n;
      return a.yAxis.reversed && (l < 0 && (l = n), h < 0 && (h = n)), {
        x: o[0],
        y: o[1],
        r: l,
        innerR: h,
        start: i,
        end: s
      };
    }
    toXY(t) {
      let e = this.series,
        i = e.chart,
        s = e.xAxis,
        a = e.yAxis,
        o = t.plotX,
        r = i.inverted,
        n = t.y,
        l = t.plotY,
        h = r ? o : a.len - l,
        p;
      if (r && e && !e.isRadialBar && (t.plotY = l = sE(n) ? a.translate(n) : 0), t.rectPlotX = o, t.rectPlotY = l, a.center && (h += a.center[3] / 2), sE(l)) {
        let e = r ? a.postTranslate(l, h) : s.postTranslate(o, h);
        t.plotX = t.polarPlotX = e.x - i.plotLeft, t.plotY = t.polarPlotY = e.y - i.plotTop;
      }
      e.kdByAngle ? ((p = (o / Math.PI * 180 + s.pane.options.startAngle) % 360) < 0 && (p += 360), t.clientX = p) : t.clientX = t.plotX;
    }
  }
  var at = f(184),
    ae = f.n(at);
  let {
      composed: ai
    } = y(),
    {
      addEvent: as,
      objectEach: aa,
      pushUnique: ao
    } = y();
  !function (t) {
    function e() {
      let t = (this || _global).waterfall?.stacks;
      t && (t.changed = !1, delete t.alreadyChanged);
    }
    function i() {
      let t = (this || _global).options.stackLabels;
      t?.enabled && (this || _global).waterfall?.stacks && (this || _global).waterfall.renderStackTotals();
    }
    function s() {
      (this || _global).waterfall || ((this || _global).waterfall = new o(this || _global));
    }
    function a() {
      let t = (this || _global).axes;
      for (let e of (this || _global).series) if (e.options.stacking) {
        for (let e of t) !e.isXAxis && e.waterfall && (e.waterfall.stacks.changed = !0);
        break;
      }
    }
    t.compose = function (t, o) {
      ao(ai, "Axis.Waterfall") && (as(t, "init", s), as(t, "afterBuildStacks", e), as(t, "afterRender", i), as(o, "beforeRedraw", a));
    };
    class o {
      constructor(t) {
        this.axis = t, this.stacks = {
          changed: !1
        };
      }
      renderStackTotals() {
        let t = this.axis,
          e = t.waterfall?.stacks,
          i = t.stacking?.stackTotalGroup,
          s = new (ae())(t, t.options.stackLabels || {}, !1, 0, void 0);
        this.dummyStackItem = s, i && aa(e, t => {
          aa(t, (t, e) => {
            s.total = t.stackTotal, s.x = +e, t.label && (s.label = t.label), ae().prototype.render.call(s, i), t.label = s.label, delete s.label;
          });
        }), s.total = null;
      }
    }
    t.Composition = o;
  }(c || (c = {}));
  let ar = c,
    {
      isNumber: an
    } = y();
  class al extends tf().prototype.pointClass {
    getClassName() {
      let t = tj().prototype.getClassName.call(this);
      return this.isSum ? t += " highcharts-sum" : this.isIntermediateSum && (t += " highcharts-intermediate-sum"), t;
    }
    isValid() {
      return an(this.y) || this.isSum || !!this.isIntermediateSum;
    }
  }
  let {
      column: ah,
      line: ap
    } = P().seriesTypes,
    {
      addEvent: ad,
      arrayMax: ac,
      arrayMin: au,
      correctFloat: ag,
      crisp: af,
      extend: am,
      isNumber: ab,
      merge: ay,
      objectEach: ax,
      pick: aP
    } = y();
  function aM(t, e) {
    return Object.hasOwnProperty.call(t, e);
  }
  class av extends ah {
    generatePoints() {
      ah.prototype.generatePoints.apply(this);
      let t = this.getColumn("y", !0);
      for (let e = 0, i = this.points.length; e < i; e++) {
        let i = this.points[e],
          s = t[e];
        ab(s) && (i.isIntermediateSum || i.isSum) && (i.y = ag(s));
      }
    }
    processData(t) {
      let e,
        i,
        s,
        a,
        o,
        r,
        n = this.options,
        l = this.getColumn("y"),
        h = n.data,
        p = l.length,
        d = n.threshold || 0;
      s = i = a = o = 0;
      for (let t = 0; t < p; t++) r = l[t], e = h?.[t] || {}, "sum" === r || e.isSum ? l[t] = ag(s) : "intermediateSum" === r || e.isIntermediateSum ? (l[t] = ag(i), i = 0) : (s += r, i += r), a = Math.min(s, a), o = Math.max(s, o);
      super.processData.call(this, t), n.stacking || (this.dataMin = a + d, this.dataMax = o);
    }
    toYData(t) {
      return t.isSum ? "sum" : t.isIntermediateSum ? "intermediateSum" : t.y;
    }
    pointAttribs(t, e) {
      let i = this.options.upColor;
      i && !t.options.color && ab(t.y) && (t.color = t.y > 0 ? i : void 0);
      let s = ah.prototype.pointAttribs.call(this, t, e);
      return delete s.dashstyle, s;
    }
    getGraphPath() {
      return this.graph?.pathArray || [["M", 0, 0]];
    }
    getCrispPath() {
      let t = this.points.filter(t => ab(t.y)),
        e = this.yAxis,
        i = t.length,
        s = this.graph?.strokeWidth() || 0,
        a = this.xAxis.reversed,
        o = this.yAxis.reversed,
        r = this.options.stacking,
        n = [];
      for (let l = 1; l < i; l++) {
        if (!(this.options.connectNulls || ab(this.data[t[l].index - 1].y))) continue;
        let i = t[l].box,
          h = t[l - 1],
          p = h.y || 0,
          d = t[l - 1].box;
        if (!i || !d) continue;
        let c = e.waterfall?.stacks[this.stackKey],
          u = p > 0 ? -d.height : 0;
        if (c && d && i) {
          let t,
            p = c[l - 1];
          t = r ? af(e.translate(p.connectorThreshold || 0, !1, !0, !1, !0) + (o ? u : 0), s) : af(d.y + (h.minPointLengthOffset || 0), s), n.push(["M", (d.x || 0) + (a ? 0 : d.width || 0), t], ["L", (i.x || 0) + (a && i.width || 0), t]);
        }
        if (d && n.length && (!r && p < 0 && !o || p > 0 && o)) {
          let t = n[n.length - 2];
          t && "number" == typeof t[2] && (t[2] += d.height || 0);
          let e = n[n.length - 1];
          e && "number" == typeof e[2] && (e[2] += d.height || 0);
        }
      }
      return n;
    }
    drawGraph() {
      ap.prototype.drawGraph.call(this), this.graph?.animate({
        d: this.getCrispPath()
      });
    }
    setStackedPoints(t) {
      let e = this.options,
        i = t.waterfall?.stacks,
        s = e.threshold || 0,
        a = this.stackKey,
        o = this.getColumn("x"),
        r = this.getColumn("y"),
        n = o.length,
        l = s,
        h = l,
        p,
        d = 0,
        c = 0,
        u = 0,
        g,
        f,
        m,
        b,
        y,
        x,
        P,
        M,
        v = (t, e, i, s) => {
          if (p) {
            if (g) for (; i < g; i++) p.stackState[i] += s;else p.stackState[0] = t, g = p.stackState.length;
            p.stackState.push(p.stackState[g - 1] + e);
          }
        };
      if (t.stacking && i && this.reserveSpace()) {
        M = i.changed, (P = i.alreadyChanged) && 0 > P.indexOf(a) && (M = !0), i[a] || (i[a] = {});
        let t = i[a];
        if (t) for (let i = 0; i < n; i++) (!t[x = o[i]] || M) && (t[x] = {
          negTotal: 0,
          posTotal: 0,
          stackTotal: 0,
          threshold: 0,
          stateIndex: 0,
          stackState: [],
          label: M && t[x] ? t[x].label : void 0
        }), p = t[x], (y = r[i]) >= 0 ? p.posTotal += y : p.negTotal += y, b = e.data[i], f = p.absolutePos = p.posTotal, m = p.absoluteNeg = p.negTotal, p.stackTotal = f + m, g = p.stackState.length, b?.isIntermediateSum ? (v(u, c, 0, u), u = c, c = s, l ^= h, h ^= l, l ^= h) : b?.isSum ? (v(s, d, g, 0), l = s) : (v(l, y, 0, d), b && (d += y, c += y)), p.stateIndex++, p.threshold = l, l += p.stackTotal;
        i.changed = !1, i.alreadyChanged || (i.alreadyChanged = []), i.alreadyChanged.push(a);
      }
    }
    getExtremes() {
      let t,
        e,
        i = this.options.stacking,
        s = this.yAxis,
        a = s.waterfall?.stacks;
      return i && a ? (t = this.stackedYNeg = [], e = this.stackedYPos = [], "overlap" === i ? ax(a[this.stackKey], function (i) {
        t.push(au(i.stackState)), e.push(ac(i.stackState));
      }) : ax(a[this.stackKey], function (i) {
        t.push(i.negTotal + i.threshold), e.push(i.posTotal + i.threshold);
      }), {
        dataMin: au(t),
        dataMax: ac(e)
      }) : {
        dataMin: this.dataMin,
        dataMax: this.dataMax
      };
    }
  }
  av.defaultOptions = ay(ah.defaultOptions, {
    dataLabels: {
      inside: !0
    },
    lineWidth: 1,
    lineColor: "#333333",
    dashStyle: "Dot",
    borderColor: "#333333",
    states: {
      hover: {
        lineWidthPlus: 0
      }
    }
  }), av.compose = ar.compose, am(av.prototype, {
    pointValKey: "y",
    showLine: !0,
    pointClass: al
  }), ad(av, "afterColumnTranslate", function () {
    let {
        options: t,
        points: e,
        yAxis: i
      } = this || _global,
      s = aP(t.minPointLength, 5),
      a = s / 2,
      o = t.threshold || 0,
      r = t.stacking,
      n = i.waterfall?.stacks[(this || _global).stackKey],
      l = this.getColumn("y", !0),
      h = o,
      p = o,
      d,
      c,
      u,
      g;
    for (let t = 0; t < e.length; t++) {
      let f = e[t],
        m = l[t],
        b = am({
          x: 0,
          y: 0,
          width: 0,
          height: 0
        }, f.shapeArgs || {});
      f.box = b;
      let y = [0, m],
        x = f.y || 0;
      if (r) {
        if (n) {
          let e = n[t];
          "overlap" === r ? (c = e.stackState[e.stateIndex--], d = x >= 0 ? c : c - x, aM(e, "absolutePos") && delete e.absolutePos, aM(e, "absoluteNeg") && delete e.absoluteNeg) : (x >= 0 ? (c = e.threshold + e.posTotal, e.posTotal -= x, d = c) : (c = e.threshold + e.negTotal, e.negTotal -= x, d = c - x), !e.posTotal && ab(e.absolutePos) && aM(e, "absolutePos") && (e.posTotal = e.absolutePos, delete e.absolutePos), !e.negTotal && ab(e.absoluteNeg) && aM(e, "absoluteNeg") && (e.negTotal = e.absoluteNeg, delete e.absoluteNeg)), f.isSum || (e.connectorThreshold = e.threshold + e.stackTotal), i.reversed ? (u = x >= 0 ? d - x : d + x, g = d) : (u = d, g = d - x), f.below = u <= o, b.y = i.translate(u, !1, !0, !1, !0), b.height = Math.abs(b.y - i.translate(g, !1, !0, !1, !0));
          let s = i.waterfall?.dummyStackItem;
          s && (s.x = t, s.label = n[t].label, s.setOffset((this || _global).pointXOffset || 0, (this || _global).barW || 0, (this || _global).stackedYNeg[t], (this || _global).stackedYPos[t], void 0, (this || _global).xAxis));
        }
      } else d = Math.max(p, p + x) + y[0], b.y = i.translate(d, !1, !0, !1, !0), f.isSum ? (b.y = i.translate(y[1], !1, !0, !1, !0), b.height = Math.min(i.translate(y[0], !1, !0, !1, !0), i.len) - b.y, f.below = y[1] <= o) : f.isIntermediateSum ? (x >= 0 ? (u = y[1] + h, g = h) : (u = h, g = y[1] + h), i.reversed && (u ^= g, g ^= u, u ^= g), b.y = i.translate(u, !1, !0, !1, !0), b.height = Math.abs(b.y - Math.min(i.translate(g, !1, !0, !1, !0), i.len)), h += y[1], f.below = u <= o) : (b.height = m > 0 ? i.translate(p, !1, !0, !1, !0) - b.y : i.translate(p, !1, !0, !1, !0) - i.translate(p - m, !1, !0, !1, !0), f.below = (p += m) < o), b.height < 0 && (b.y += b.height, b.height *= -1);
      f.plotY = b.y, f.yBottom = b.y + b.height, b.height <= s && !f.isNull ? (b.height = s, b.y -= a, f.yBottom = b.y + b.height, f.plotY = b.y, x < 0 ? f.minPointLengthOffset = -a : f.minPointLengthOffset = a) : (f.isNull && (b.width = 0), f.minPointLengthOffset = 0);
      let P = f.plotY + (f.negative ? b.height : 0);
      f.below && (f.plotY += b.height), f.tooltipPos && ((this || _global).chart.inverted ? f.tooltipPos[0] = i.len - P : f.tooltipPos[1] = P), f.isInside = this.isPointInside(f);
      let M = af(f.yBottom, (this || _global).borderWidth);
      b.y = af(b.y, (this || _global).borderWidth), b.height = M - b.y, ay(!0, f.shapeArgs, b);
    }
  }, {
    order: 2
  }), P().registerSeriesType("waterfall", av);
  let aL = y();
  aL.RadialAxis = sS, eo.compose(aL.Axis, aL.Chart, aL.Legend), iQ.compose(aL.Axis, aL.Chart, aL.Legend), V.compose(aL.Chart, aL.Pointer), s7.compose(aL.Axis, aL.Chart, aL.Pointer, aL.Series, aL.Tick, aL.Point, P().seriesTypes.areasplinerange, P().seriesTypes.column, P().seriesTypes.line, P().seriesTypes.spline), av.compose(aL.Axis, aL.Chart);
  let ak = aL;
  return m.default;
})());
export default exports;